(function () {
  'use strict';

  const root = document.getElementById('ym-preview');
  if (!root) return;
  if (window.__ymABRedirect) return;   // test A/B : la page part vers ?view=v5, aucun appel API ici

  // ============================================================
  //  Config from data attributes
  // ============================================================
  const locale = (root.dataset.locale || 'fr').toLowerCase();
  const apiUrl = root.dataset.apiUrl || '';
  const VARIANTS = {
    express:   { id: root.dataset.variantExpress, price: root.dataset.variantExpressPrice, compare: root.dataset.variantExpressCompare },
    standard:  { id: root.dataset.variantStandard, price: root.dataset.variantStandardPrice, compare: root.dataset.variantStandardCompare },
    streaming: { id: root.dataset.variantStreaming, price: root.dataset.variantStreamingPrice, amount: root.dataset.variantStreamingAmount },
    lyrics:    { id: root.dataset.variantLyrics, price: root.dataset.variantLyricsPrice, amount: root.dataset.variantLyricsAmount }
  };
  VARIANTS.express.amount = root.dataset.variantExpressAmount;
  VARIANTS.express.compareAmount = root.dataset.variantExpressCompareAmount;
  VARIANTS.standard.amount = root.dataset.variantStandardAmount;
  VARIANTS.standard.compareAmount = root.dataset.variantStandardCompareAmount;
  const CURRENCY = (root.dataset.currency || '').trim();
  const PHOTO_API = (root.dataset.photoApi || '').trim();

  // ============================================================
  //  i18n
  // ============================================================
  const I18N = {
    fr: {
      heroPrefix: "Découvrez la chanson personnalisée de ",
      heroSuffix: "",
      playLabel: "Cliquez pour écouter",
      pauseLabel: "Pause",
      previewLabel: "⏱ Extrait",
      durationLabel: "Aperçu 90s",
      lockedLabel: "Chanson complète verrouillée",
      emotionText: "Imaginez l'émotion sur le visage de <strong>{name}</strong> à l'écoute de cette chanson 😍. Un cadeau à garder précieusement, pour toujours.",
      capacityMain: "Plus que 3 places dans les prochaines 24h",
      capacitySub: "Pour préserver la qualité, notre studio ne produit qu'un nombre limité de chansons par jour.",
      expiryLabel: "Votre extrait reste en ligne encore",
      expirySub: "Notre studio ne conserve pas les extraits au-delà de 24h. Réservez votre chanson maintenant et <strong>profitez de modifications illimitées jusqu'à ce qu'elle vous plaise à 100%.</strong>",
      studioNoteLabel: "✍️ Le mot du studio",
      studioNoteSign: "Camille, autrice-compositrice",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-camille.png?v=1790236534&width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> a vraiment de la chance de vous avoir. Merci de nous avoir confié cette chanson, on l'a composée avec beaucoup de soin et on espère du fond du cœur qu'elle vous plaira.",
      stickyCap: "L'extrait disparaît · 3 places restantes",
      stickyCapShort: "3 places restantes",
      stickyBtn: "Débloquer",
      offerLabel: "OFFRE LIMITÉE",
      unlockPrefix: "Débloquez la chanson complète de ",
      unlockSuffix: "",
      offerSub: "Réduction valable uniquement maintenant",
      expressTitle: "Votre chanson en 30 minutes",
      expressB1: "Chanson complète dans votre boîte mail en 30 min",
      expressB2: "Priorité absolue en studio",
      expressB3: "Offre unique",
      popularBadge: "LE PLUS POPULAIRE",
      standardTitle: "Votre chanson en 48 heures",
      standardDesc: "Même chanson, livrée sous 24 heures",
      streamingTitle: "Votre chanson sur Spotify et Apple Music",
      streamingDesc: "Ajoutez-la à vos playlists du quotidien.",
      lyricsPrefix: "Gardez les paroles de",
      lyricsSuffix: " pour toujours",
      lyricsDesc: "Imprimables, avec son prénom et la pochette de la chanson. À garder, à offrir, à encadrer.",
      photoError: "Envoi impossible, réessayez.",
      photoFormat: "Ce format de photo n’est pas accepté. Essayez une photo JPG ou PNG.",
      ctaMain: "Débloquer la chanson complète",
      trust1: "Accès instantané",
      trust2: "À vous pour toujours",
      guaranteeTitle: "Garantie satisfait ou remboursé",
      guaranteeBody: "Révisions illimitées jusqu'à ce que la chanson vous plaise, ou remboursement intégral.",
      socialProof: "Plus de 20 000 chansons livrées avec amour",
      includedTitle: "Ce qui est inclus",
      inc1Title: "Accès instantané",
      inc1Desc: "Disponible immédiatement après achat",
      inc2Title: "Hébergée à vie",
      inc2Desc: "Accessible sur tous vos appareils",
      inc3Title: "Téléchargement",
      inc3Desc: "Fichier audio en haute qualité",
      inc4Title: "Modifications gratuites",
      inc4Desc: "Jusqu'à ce qu'elle vous plaise",
      faqTitle: "Questions fréquentes",
      faqQ1: "Que se passe-t-il juste après le paiement ?",
      faqA1: "Votre chanson part en production dans la minute. Le studio l'enregistre en entier, en qualité studio HD, avec la voix, les instruments et le mixage. Vous recevez ensuite un mail avec le lien privé de votre chanson : 30 minutes avec la livraison express, sous 48 heures avec la livraison classique.",
      faqQ2: "Comment l'offrir pour que le moment soit réussi ?",
      faqA2: "En voiture, dans le salon rien que tous les deux, ou devant tout le monde si c'est pour un événement. Un endroit calme, une enceinte même petite, ou le haut-parleur d'un téléphone récent. Dites simplement « écoute ».",
      faqQ3: "Sous quelle forme je reçois la chanson ?",
      faqA3: "Une page privée qui vous appartient, avec la chanson, les paroles et la photo. Le fichier reste téléchargeable depuis cette page quand vous le souhaitez.",
      faqQ4: "Puis-je demander des modifications ?",
      faqA4: "Oui, autant de fois que nécessaire et sans frais pendant 7 jours. Un prénom, une phrase, un couplet entier : on refait et on vous renvoie la nouvelle version.",
      faqQ5: "Le paiement est-il sécurisé ?",
      faqA5: "Oui. Tous les paiements sont traités par Shopify avec un chiffrement bancaire. Nous ne stockons jamais vos données de carte.",
      loading: "Chargement de votre extrait…",
      errorTitle: "Extrait introuvable",
      errorBody: "Le lien que vous avez utilisé n'est pas valide ou a expiré.",
      errorCta: "Recommencer le quiz",
      pendingTitle: "Votre extrait se prépare…",
      pendingBody: "Nous composons votre chanson personnalisée. Vous recevrez un email dès qu'elle sera prête.",
      pendingHint: "🎧 Votre extrait apparaîtra ici quand il sera prêt.",
      pendingLate: "Votre chanson prend un peu plus de temps que prévu. Pas d'inquiétude : dès qu'elle est prête, vous la recevez par email et cette page se met à jour.",
      cartError: "Une erreur est survenue. Vérifiez votre connexion et réessayez.",
      saveLabel: "Économie",
      // line item property labels (FR)
      propRecipient: "Pour qui",
      propRecipientName: "Prénom destinataire",
      propStyle: "Style",
      propOccasion: "Occasion",
      propPreviewUrl: "Extrait écouté",
      propStylePrompt: "Style musical",
      propLyrics: "Paroles"
    },
    en: {
      heroPrefix: "Discover ",
      heroSuffix: "'s personalized song",
      playLabel: "Tap to play preview",
      pauseLabel: "Pause",
      previewLabel: "⏱ Preview",
      durationLabel: "90s preview",
      lockedLabel: "Full song locked",
      emotionText: "Picture the look on <strong>{name}</strong>'s face hearing this song 😍. A timeless gift to treasure forever.",
      capacityMain: "Only 3 slots left in the next 24h",
      capacitySub: "To keep the quality high, our studio only produces a limited number of songs each day.",
      expiryLabel: "Your preview stays online for",
      expirySub: "Our studio doesn't keep previews beyond 24h. Order your song now and <strong>enjoy unlimited revisions until you love it.</strong>",
      studioNoteLabel: "✍️ A note from our studio",
      studioNoteSign: "Emma, songwriter",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-emma.png?v=1790236534&width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> is so lucky to have you. Thank you for trusting us with this song. We crafted it with great care and truly hope you'll love it.",
      stickyCap: "Preview disappears · 3 slots left",
      stickyCapShort: "3 slots left",
      stickyBtn: "Unlock",
      offerLabel: "LIMITED OFFER",
      unlockPrefix: "Unlock ",
      unlockSuffix: "'s full song now",
      offerSub: "One time offer",
      expressTitle: "Your song in 30 minutes",
      expressB1: "Full song in your inbox in 30 minutes",
      expressB2: "Studio absolute priority",
      expressB3: "One time offer",
      popularBadge: "MOST POPULAR",
      standardTitle: "Your song in 48 hours",
      standardDesc: "Same song, delivered within 24 hours",
      streamingTitle: "Your song on Spotify and Apple Music",
      streamingDesc: "Add it to your everyday playlists.",
      lyricsPrefix: "Keep",
      lyricsSuffix: "'s lyrics forever",
      lyricsDesc: "Printable, with their name and the song's cover art. Keep it, gift it, frame it.",
      photoError: "Upload failed, please try again.",
      photoFormat: "This photo format isn’t supported. Try a JPG or PNG.",
      ctaMain: "Unlock full song",
      trust1: "Instant access",
      trust2: "Yours forever",
      guaranteeTitle: "Money-back guarantee",
      guaranteeBody: "Unlimited revisions until you love the song, or a full refund.",
      socialProof: "20,000+ custom songs delivered with love",
      includedTitle: "What's Included",
      inc1Title: "Instant access",
      inc1Desc: "Unlock immediately after purchase",
      inc2Title: "Hosted forever",
      inc2Desc: "Access on any device, anytime",
      inc3Title: "Download anytime",
      inc3Desc: "HD audio file",
      inc4Title: "Free revisions",
      inc4Desc: "Until you love it",
      faqTitle: "Frequently Asked Questions",
      faqQ1: "What happens right after I pay?",
      faqA1: "Your song goes into production within the minute. The studio records it in full, in HD studio quality, with vocals, instruments and mixing. You then get an email with the private link to your song: 30 minutes with express delivery, within 48 hours with standard delivery.",
      faqQ2: "How do I give it so the moment lands?",
      faqA2: "In the car, in the living room just the two of you, or in front of everyone if it is for an event. A quiet spot, a speaker even a small one, or a recent phone speaker. Just say « listen ».",
      faqQ3: "How do I get the song?",
      faqA3: "A private page that is yours, with the song, the lyrics and the photo. The file stays downloadable from that page whenever you want.",
      faqQ4: "Can I request modifications?",
      faqA4: "Yes, as many times as you need and at no cost for 7 days. A first name, a line, a whole verse: we redo it and send you the new version.",
      faqQ5: "Is my payment secure?",
      faqA5: "Yes. All payments are processed by Shopify with bank-grade encryption. We never store your card details.",
      loading: "Loading your preview…",
      errorTitle: "Preview not found",
      errorBody: "The link you used is invalid or has expired.",
      errorCta: "Start over",
      pendingTitle: "Your preview is being created…",
      pendingBody: "We're composing your personalized song. You'll receive an email as soon as it's ready.",
      pendingHint: "🎧 Your preview will appear here as soon as it is ready.",
      pendingLate: "Your song is taking a little longer than expected. No worries: as soon as it's ready you'll get it by email, and this page will update.",
      cartError: "Something went wrong. Check your connection and try again.",
      saveLabel: "Save",
      propRecipient: "For whom",
      propRecipientName: "Recipient first name",
      propStyle: "Music style",
      propOccasion: "Occasion",
      propPreviewUrl: "Preview heard",
      propStylePrompt: "Style prompt",
      propLyrics: "Lyrics"
    },
    de: {
      heroPrefix: "Entdecken Sie das personalisierte Lied für ",
      heroSuffix: "",
      playLabel: "Klicken Sie, um anzuhören",
      pauseLabel: "Pause",
      previewLabel: "⏱ Ausschnitt",
      durationLabel: "90s Vorschau",
      lockedLabel: "Vollständiges Lied gesperrt",
      emotionText: "Stellen Sie sich den Ausdruck auf <strong>{name}</strong>s Gesicht beim Hören dieses Liedes vor 😍. Ein zeitloses Geschenk für die Ewigkeit.",
      capacityMain: "Nur noch 3 Plätze in den nächsten 24h",
      capacitySub: "Um die Qualität zu sichern, produziert unser Studio nur eine begrenzte Anzahl Lieder pro Tag.",
      expiryLabel: "Ihre Hörprobe bleibt noch online",
      expirySub: "Unser Studio bewahrt Ausschnitte nicht länger als 24h auf. Bestellen Sie Ihr Lied jetzt und <strong>profitieren Sie von unbegrenzten Änderungen, bis es Ihnen gefällt.</strong>",
      studioNoteLabel: "✍️ Ein Wort aus unserem Studio",
      studioNoteSign: "Lena, Songwriterin",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-lena.png?v=1790236534&width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> kann sich glücklich schätzen, Sie zu haben. Danke, dass Sie uns dieses Lied anvertraut haben. Wir haben es mit viel Sorgfalt gestaltet und hoffen von Herzen, dass es Ihnen gefällt.",
      stickyCap: "Hörprobe verschwindet · 3 Plätze frei",
      stickyCapShort: "3 Plätze frei",
      stickyBtn: "Freischalten",
      offerLabel: "BEFRISTETES ANGEBOT",
      unlockPrefix: "Schalten Sie das vollständige Lied von ",
      unlockSuffix: " frei",
      offerSub: "Rabatt nur jetzt gültig",
      expressTitle: "Ihr Lied in 30 Minuten",
      expressB1: "Vollständiges Lied per E-Mail in 30 Min",
      expressB2: "Studio absolute Priorität",
      expressB3: "Einmaliges Angebot",
      popularBadge: "AM BELIEBTESTEN",
      standardTitle: "Ihr Lied in 48 Stunden",
      standardDesc: "Gleiches Lied, geliefert innerhalb von 24 Stunden",
      streamingTitle: "Ihr Lied auf Spotify und Apple Music",
      streamingDesc: "Fügen Sie es Ihren täglichen Playlists hinzu.",
      lyricsPrefix: "Bewahren Sie den Text von",
      lyricsSuffix: " für immer",
      lyricsDesc: "Zum Ausdrucken, mit dem Vornamen und dem Cover des Liedes. Aufbewahren, verschenken, rahmen.",
      photoError: "Senden fehlgeschlagen, bitte erneut versuchen.",
      photoFormat: "Dieses Fotoformat wird nicht unterstützt. Versuchen Sie JPG oder PNG.",
      ctaMain: "Vollständiges Lied freischalten",
      trust1: "Sofortiger Zugang",
      trust2: "Für immer Ihnen",
      guaranteeTitle: "Zufrieden oder Geld zurück",
      guaranteeBody: "Unbegrenzte Überarbeitungen, bis Ihnen das Lied gefällt, oder volle Rückerstattung.",
      socialProof: "Über 20.000 Lieder mit Liebe geliefert",
      includedTitle: "Was enthalten ist",
      inc1Title: "Sofortiger Zugang",
      inc1Desc: "Sofort nach dem Kauf verfügbar",
      inc2Title: "Für immer gehostet",
      inc2Desc: "Zugriff auf jedem Gerät",
      inc3Title: "Jederzeit herunterladen",
      inc3Desc: "HD-Audiodatei",
      inc4Title: "Kostenlose Überarbeitungen",
      inc4Desc: "Bis es Ihnen gefällt",
      faqTitle: "Häufig gestellte Fragen",
      faqQ1: "Was passiert direkt nach der Zahlung?",
      faqA1: "Ihr Lied geht sofort in Produktion. Das Studio nimmt es vollständig auf, in HD-Studioqualität, mit Gesang, Instrumenten und Mix. Danach erhalten Sie eine E-Mail mit dem privaten Link zu Ihrem Lied: 30 Minuten mit Express-Lieferung, innerhalb von 48 Stunden mit der klassischen Lieferung.",
      faqQ2: "Wie verschenke ich es, damit der Moment sitzt?",
      faqA2: "Im Auto, im Wohnzimmer nur zu zweit, oder vor allen, wenn es für ein Fest ist. Ein ruhiger Ort, ein Lautsprecher, auch ein kleiner, oder der Lautsprecher eines neueren Handys. Sagen Sie einfach « hör mal ».",
      faqQ3: "In welcher Form erhalte ich das Lied?",
      faqA3: "Eine private Seite, die Ihnen gehört, mit dem Lied, dem Text und dem Foto. Die Datei bleibt dort jederzeit zum Herunterladen.",
      faqQ4: "Kann ich Änderungen verlangen?",
      faqA4: "Ja, so oft Sie möchten und kostenlos, 7 Tage lang. Ein Vorname, eine Zeile, eine ganze Strophe: wir machen es neu und schicken Ihnen die neue Version.",
      faqQ5: "Ist die Zahlung sicher?",
      faqA5: "Ja. Alle Zahlungen laufen über Shopify mit bankenüblicher Verschlüsselung. Wir speichern Ihre Kartendaten nie.",
      loading: "Ihre Vorschau wird geladen…",
      errorTitle: "Vorschau nicht gefunden",
      errorBody: "Der verwendete Link ist ungültig oder abgelaufen.",
      errorCta: "Von vorne beginnen",
      pendingTitle: "Ihre Vorschau wird vorbereitet…",
      pendingBody: "Wir komponieren Ihr personalisiertes Lied. Sie erhalten eine E-Mail, sobald es fertig ist.",
      pendingHint: "🎧 Ihre Hörprobe erscheint hier, sobald sie fertig ist.",
      pendingLate: "Ihr Lied dauert etwas länger als erwartet. Keine Sorge: sobald es fertig ist, erhalten Sie es per E-Mail, und diese Seite wird aktualisiert.",
      cartError: "Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      saveLabel: "Sparen",
      propRecipient: "Für wen",
      propRecipientName: "Vorname Empfänger",
      propStyle: "Musikstil",
      propOccasion: "Anlass",
      propPreviewUrl: "Gehörter Ausschnitt",
      propStylePrompt: "Musikstil-Beschreibung",
      propLyrics: "Songtext"
    },
    ja: {
      heroPrefix: "",
      heroSuffix: "へ贈る、世界にひとつの歌",
      playLabel: "タップして試聴する",
      pauseLabel: "一時停止",
      previewLabel: "⏱ 試聴版",
      durationLabel: "90秒の試聴",
      lockedLabel: "フルバージョンはロック中です",
      emotionText: "この歌を聴いたときの<strong>{name}</strong>の表情を想像してみてください 😍。ずっと大切にしてもらえる、一生ものの贈り物です。",
      capacityMain: "今後24時間の制作枠は残り3つです",
      capacitySub: "品質を守るため、スタジオで制作できる曲数は1日あたり限られています。",
      expiryLabel: "試聴版の公開期間はあと",
      expirySub: "試聴版は24時間を過ぎると削除されます。今のうちにご注文いただければ、<strong>気に入っていただけるまで何度でも無料で修正します。</strong>",
      studioNoteLabel: "✍️ スタジオからのひとこと",
      studioNoteSign: "ソングライター ユイ",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-yui.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong>は、あなたがそばにいて本当に幸せですね。この歌を私たちに託してくださり、ありがとうございます。心を込めてつくりました。気に入っていただけたら、とてもうれしいです。",
      stickyCap: "試聴版はまもなく削除 · 残り3枠",
      stickyCapShort: "残り3枠",
      stickyBtn: "フルで聴く",
      offerLabel: "期間限定",
      unlockPrefix: "",
      unlockSuffix: "への歌を、フルバージョンで",
      offerSub: "今だけの特別価格です",
      expressTitle: "あなたの歌を30分でお届け",
      expressB1: "30分以内にフルバージョンをメールでお届け",
      expressB2: "スタジオで最優先に制作",
      expressB3: "今だけの特別オファー",
      popularBadge: "いちばん人気",
      standardTitle: "あなたの歌を48時間以内にお届け",
      standardDesc: "同じ歌を48時間以内にお届け",
      streamingTitle: "あなたの歌をSpotifyとApple Musicで配信",
      streamingDesc: "いつものプレイリストに加えて楽しめます。",
      lyricsPrefix: "",
      lyricsSuffix: "への歌詞を、ずっと手元に",
      lyricsDesc: "お名前と歌のジャケット入りで、印刷してお使いいただけます。手元に残しても、贈っても、額に入れて飾っても。",
      photoError: "送信できませんでした。もう一度お試しください。",
      photoFormat: "この形式の写真には対応していません。JPGかPNGでお試しください。",
      ctaMain: "フルバージョンを受け取る",
      trust1: "すぐに聴ける",
      trust2: "ずっとあなたのもの",
      guaranteeTitle: "満足保証・全額返金",
      guaranteeBody: "気に入っていただけるまで何度でも修正します。それでもご満足いただけない場合は、全額返金いたします。",
      socialProof: "20,000曲以上を心を込めてお届けしました",
      includedTitle: "含まれるもの",
      inc1Title: "すぐに聴ける",
      inc1Desc: "ご購入後すぐにお楽しみいただけます",
      inc2Title: "ずっと保存",
      inc2Desc: "どの端末からでも、いつでも聴けます",
      inc3Title: "いつでもダウンロード",
      inc3Desc: "高音質の音声ファイル",
      inc4Title: "無料で修正",
      inc4Desc: "気に入っていただけるまで",
      faqTitle: "よくあるご質問",
      faqQ1: "お支払いのあとは、どうなりますか？",
      faqA1: "1分以内に制作がはじまります。スタジオで歌、楽器、ミックスまで、HDのスタジオ品質でフルバージョンを収録します。完成したら、あなただけの歌の非公開リンクをメールでお送りします。お急ぎ便なら30分、通常便なら48時間以内にお届けします。",
      faqQ2: "どんなふうに贈ると、いちばん喜ばれますか？",
      faqA2: "車の中で、ふたりきりのリビングで、またはイベントならみんなの前で。静かな場所と、小さなスピーカーか最近のスマートフォンがあれば十分です。「聴いてみて」とひとこと伝えるだけで大丈夫です。",
      faqQ3: "歌はどんな形で受け取れますか？",
      faqA3: "歌と歌詞、写真がそろった、あなた専用の非公開ページをご用意します。音声ファイルはこのページからいつでもダウンロードできます。",
      faqQ4: "修正をお願いできますか？",
      faqA4: "はい、7日間は何度でも無料で修正します。お名前ひとつ、フレーズひとつ、1番まるごとでも、作り直して新しいバージョンをお送りします。",
      faqQ5: "お支払いは安全ですか？",
      faqA5: "はい。お支払いはすべてShopifyが銀行レベルの暗号化で処理します。カード情報を当店で保存することは一切ありません。",
      loading: "試聴版を読み込んでいます…",
      errorTitle: "試聴版が見つかりません",
      errorBody: "ご利用のリンクが正しくないか、有効期限が切れています。",
      errorCta: "最初からやり直す",
      pendingTitle: "試聴版をつくっています…",
      pendingBody: "あなただけの歌を制作しています。できあがったら、すぐにメールでお知らせします。",
      pendingHint: "🎧 試聴版ができあがると、ここに表示されます。",
      pendingLate: "予定より少し時間がかかっています。ご安心ください。できあがり次第メールでお届けし、このページも自動で更新されます。",
      cartError: "エラーが発生しました。通信環境をご確認のうえ、もう一度お試しください。",
      saveLabel: "お得",
      propRecipient: "贈る相手",
      propRecipientName: "贈る相手のお名前",
      propStyle: "曲のスタイル",
      propOccasion: "贈る機会",
      propPreviewUrl: "聴いた試聴版",
      propStylePrompt: "スタイルの指定",
      propLyrics: "歌詞"
    },
    it: {
      heroPrefix: "Scopri la canzone personalizzata per ",
      heroSuffix: "",
      playLabel: "Tocca per ascoltare",
      pauseLabel: "Pausa",
      previewLabel: "⏱ Anteprima",
      durationLabel: "Anteprima di 90s",
      lockedLabel: "Canzone completa bloccata",
      emotionText: "Immagina l'espressione di <strong>{name}</strong> mentre ascolta questa canzone 😍. Un regalo da custodire per sempre.",
      capacityMain: "Solo 3 posti liberi nelle prossime 24h",
      capacitySub: "Per garantire la qualità, il nostro studio realizza solo un numero limitato di canzoni al giorno.",
      expiryLabel: "La tua anteprima resta online ancora per",
      expirySub: "Il nostro studio non conserva le anteprime oltre le 24h. Ordina ora la tua canzone e <strong>avrai modifiche illimitate finché non ti piacerà al 100%.</strong>",
      studioNoteLabel: "✍️ Due parole dal nostro studio",
      studioNoteSign: "Giulia, cantautrice",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-giulia.png?width=96&height=96&crop=center",
      studioNoteFallback: "Che fortuna per <strong>{name}</strong> avere accanto una persona come te. Grazie per averci affidato questa canzone: l'abbiamo scritta con tanta cura e speriamo con tutto il cuore che ti piaccia.",
      stickyCap: "L'anteprima sta per sparire · 3 posti rimasti",
      stickyCapShort: "3 posti rimasti",
      stickyBtn: "Sblocca",
      offerLabel: "OFFERTA LIMITATA",
      unlockPrefix: "Sblocca la canzone completa per ",
      unlockSuffix: "",
      offerSub: "Sconto valido solo adesso",
      expressTitle: "La tua canzone in 30 minuti",
      expressB1: "Canzone completa nella tua email in 30 minuti",
      expressB2: "Massima priorità in studio",
      expressB3: "Offerta unica",
      popularBadge: "LA PIÙ SCELTA",
      standardTitle: "La tua canzone in 48 ore",
      standardDesc: "Stessa canzone, consegnata entro 48 ore",
      streamingTitle: "La tua canzone su Spotify e Apple Music",
      streamingDesc: "Aggiungila alle tue playlist di tutti i giorni.",
      lyricsPrefix: "Il testo della canzone di",
      lyricsSuffix: ", da conservare per sempre",
      lyricsDesc: "Da stampare, con il suo nome e la copertina della canzone. Da conservare, regalare, incorniciare.",
      photoError: "Invio non riuscito, riprova.",
      photoFormat: "Questo formato di foto non è supportato. Prova con un JPG o un PNG.",
      ctaMain: "Sblocca la canzone completa",
      trust1: "Accesso immediato",
      trust2: "Tua per sempre",
      guaranteeTitle: "Soddisfatto o rimborsato",
      guaranteeBody: "Modifiche illimitate finché la canzone non ti piace, oppure rimborso completo.",
      socialProof: "Oltre 20.000 canzoni consegnate con amore",
      includedTitle: "Cosa è incluso",
      inc1Title: "Accesso immediato",
      inc1Desc: "Disponibile subito dopo l'acquisto",
      inc2Title: "Online per sempre",
      inc2Desc: "Da qualsiasi dispositivo, quando vuoi",
      inc3Title: "Download quando vuoi",
      inc3Desc: "File audio in alta qualità",
      inc4Title: "Modifiche gratuite",
      inc4Desc: "Finché non ti piace",
      faqTitle: "Domande frequenti",
      faqQ1: "Cosa succede subito dopo il pagamento?",
      faqA1: "La tua canzone entra in produzione entro un minuto. Lo studio la registra per intero, in qualità studio HD, con voce, strumenti e mixaggio. Poi ricevi un'email con il link privato alla tua canzone: in 30 minuti con la consegna express, entro 48 ore con la consegna standard.",
      faqQ2: "Come regalarla perché il momento sia perfetto?",
      faqA2: "In macchina, in salotto solo voi due, o davanti a tutti se è per un evento. Un posto tranquillo, una cassa anche piccola, o l'altoparlante di un telefono recente. Basta dire «ascolta».",
      faqQ3: "In che forma ricevo la canzone?",
      faqA3: "Una pagina privata tutta tua, con la canzone, il testo e la foto. Da quella pagina puoi scaricare il file quando vuoi.",
      faqQ4: "Posso chiedere modifiche?",
      faqA4: "Sì, tutte le volte che serve e senza costi per 7 giorni. Un nome, una frase, una strofa intera: la rifacciamo e ti mandiamo la nuova versione.",
      faqQ5: "Il pagamento è sicuro?",
      faqA5: "Sì. Tutti i pagamenti sono gestiti da Shopify con crittografia di livello bancario. Non salviamo mai i dati della tua carta.",
      loading: "Caricamento della tua anteprima…",
      errorTitle: "Anteprima non trovata",
      errorBody: "Il link che hai usato non è valido o è scaduto.",
      errorCta: "Ricomincia",
      pendingTitle: "Stiamo preparando la tua anteprima…",
      pendingBody: "Stiamo componendo la tua canzone personalizzata. Riceverai un'email appena sarà pronta.",
      pendingHint: "🎧 La tua anteprima apparirà qui appena sarà pronta.",
      pendingLate: "La tua canzone richiede un po' più tempo del previsto. Nessuna preoccupazione: appena è pronta la ricevi via email e questa pagina si aggiorna.",
      cartError: "Si è verificato un errore. Controlla la connessione e riprova.",
      saveLabel: "Risparmi",
      propRecipient: "Per chi",
      propRecipientName: "Nome destinatario",
      propStyle: "Stile musicale",
      propOccasion: "Occasione",
      propPreviewUrl: "Anteprima ascoltata",
      propStylePrompt: "Descrizione stile",
      propLyrics: "Testo"
    },
    nl: {
      heroPrefix: "Ontdek het persoonlijke lied voor ",
      heroSuffix: "",
      playLabel: "Tik om te luisteren",
      pauseLabel: "Pauze",
      previewLabel: "⏱ Fragment",
      durationLabel: "Fragment van 90 s",
      lockedLabel: "Volledig lied vergrendeld",
      emotionText: "Stel je de blik van <strong>{name}</strong> voor bij het horen van dit lied 😍. Een cadeau om voor altijd te koesteren.",
      capacityMain: "Nog maar 3 plekken vrij in de komende 24 uur",
      capacitySub: "Om de kwaliteit hoog te houden, maakt onze studio maar een beperkt aantal liedjes per dag.",
      expiryLabel: "Je fragment blijft nog online voor",
      expirySub: "Onze studio bewaart fragmenten niet langer dan 24 uur. Bestel je lied nu en <strong>geniet van onbeperkte aanpassingen tot je er helemaal blij mee bent.</strong>",
      studioNoteLabel: "✍️ Een woordje van onze studio",
      studioNoteSign: "Sanne, songwriter",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-sanne.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> mag zich gelukkig prijzen met jou. Bedankt dat je ons dit lied toevertrouwt. We hebben het met veel zorg gemaakt en hopen van harte dat je het prachtig vindt.",
      stickyCap: "Fragment verdwijnt · nog 3 plekken",
      stickyCapShort: "Nog 3 plekken",
      stickyBtn: "Ontgrendel",
      offerLabel: "TIJDELIJK AANBOD",
      unlockPrefix: "Ontgrendel nu het volledige lied voor ",
      unlockSuffix: "",
      offerSub: "Korting alleen nu geldig",
      expressTitle: "Je lied binnen 30 minuten",
      expressB1: "Volledig lied binnen 30 minuten in je mailbox",
      expressB2: "Absolute voorrang in de studio",
      expressB3: "Eenmalig aanbod",
      popularBadge: "MEEST GEKOZEN",
      standardTitle: "Je lied binnen 48 uur",
      standardDesc: "Hetzelfde lied, geleverd binnen 48 uur",
      streamingTitle: "Je lied op Spotify en Apple Music",
      streamingDesc: "Zet het in je dagelijkse playlists.",
      lyricsPrefix: "De songtekst voor",
      lyricsSuffix: ", om altijd te bewaren",
      lyricsDesc: "Om te printen, met de naam en de cover van het lied. Om te bewaren, te geven of in te lijsten.",
      photoError: "Verzenden mislukt, probeer het opnieuw.",
      photoFormat: "Dit fotoformaat wordt niet ondersteund. Probeer een JPG of PNG.",
      ctaMain: "Ontgrendel het volledige lied",
      trust1: "Direct toegang",
      trust2: "Voor altijd van jou",
      guaranteeTitle: "Niet goed, geld terug",
      guaranteeBody: "Onbeperkt aanpassingen tot je het lied geweldig vindt, of je geld volledig terug.",
      socialProof: "Meer dan 20.000 liedjes met liefde geleverd",
      includedTitle: "Wat je krijgt",
      inc1Title: "Direct toegang",
      inc1Desc: "Meteen beschikbaar na aankoop",
      inc2Title: "Voor altijd online",
      inc2Desc: "Op elk apparaat, wanneer je wilt",
      inc3Title: "Altijd te downloaden",
      inc3Desc: "Audiobestand in hoge kwaliteit",
      inc4Title: "Gratis aanpassingen",
      inc4Desc: "Tot je er blij mee bent",
      faqTitle: "Veelgestelde vragen",
      faqQ1: "Wat gebeurt er direct na de betaling?",
      faqA1: "Je lied gaat binnen een minuut in productie. De studio neemt het volledig op, in HD-studiokwaliteit, met zang, instrumenten en mix. Daarna krijg je een e-mail met de privélink naar je lied: binnen 30 minuten met expreslevering, binnen 48 uur met standaardlevering.",
      faqQ2: "Hoe geef ik het zo dat het moment echt binnenkomt?",
      faqA2: "In de auto, samen op de bank, of voor iedereen als het voor een feest is. Een rustig plekje, een speaker (een kleintje is ook prima) of de luidspreker van een recente telefoon. Zeg gewoon: ‘luister even’.",
      faqQ3: "Hoe ontvang ik het lied?",
      faqA3: "Een privépagina die helemaal van jou is, met het lied, de songtekst en de foto. Het bestand kun je daar downloaden wanneer je maar wilt.",
      faqQ4: "Kan ik aanpassingen vragen?",
      faqA4: "Ja, zo vaak als nodig en 7 dagen lang kosteloos. Een naam, een zin, een heel couplet: we passen het aan en sturen je de nieuwe versie.",
      faqQ5: "Is betalen veilig?",
      faqA5: "Ja. Alle betalingen worden verwerkt door Shopify met versleuteling op bankniveau. We slaan je kaartgegevens nooit op.",
      loading: "Je fragment wordt geladen…",
      errorTitle: "Fragment niet gevonden",
      errorBody: "De link die je gebruikte is ongeldig of verlopen.",
      errorCta: "Opnieuw beginnen",
      pendingTitle: "Je fragment wordt gemaakt…",
      pendingBody: "We componeren je persoonlijke lied. Je krijgt een e-mail zodra het klaar is.",
      pendingHint: "🎧 Je fragment verschijnt hier zodra het klaar is.",
      pendingLate: "Je lied duurt iets langer dan verwacht. Geen zorgen: zodra het klaar is, krijg je het per e-mail en wordt deze pagina bijgewerkt.",
      cartError: "Er ging iets mis. Controleer je verbinding en probeer het opnieuw.",
      saveLabel: "Bespaar",
      propRecipient: "Voor wie",
      propRecipientName: "Voornaam ontvanger",
      propStyle: "Muziekstijl",
      propOccasion: "Gelegenheid",
      propPreviewUrl: "Beluisterd fragment",
      propStylePrompt: "Stijlomschrijving",
      propLyrics: "Songtekst"
    },
    sv: {
      heroPrefix: "Upptäck den personliga låten till ",
      heroSuffix: "",
      playLabel: "Tryck för att lyssna",
      pauseLabel: "Paus",
      previewLabel: "⏱ Smakprov",
      durationLabel: "Smakprov på 90 s",
      lockedLabel: "Hela låten är låst",
      emotionText: "Föreställ dig reaktionen när <strong>{name}</strong> hör den här låten 😍. En tidlös gåva att spara för alltid.",
      capacityMain: "Bara 3 platser kvar de närmaste 24 timmarna",
      capacitySub: "För att hålla kvaliteten hög gör vår studio bara ett begränsat antal låtar per dag.",
      expiryLabel: "Ditt smakprov finns kvar online i",
      expirySub: "Vår studio sparar inte smakprov längre än 24 timmar. Beställ din låt nu och <strong>få obegränsat med ändringar tills du är helt nöjd.</strong>",
      studioNoteLabel: "✍️ Ett ord från vår studio",
      studioNoteSign: "Elin, låtskrivare",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-elin.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> har tur som har dig. Tack för att du anförtror oss den här låten. Vi har gjort den med stor omsorg och hoppas verkligen att du kommer att älska den.",
      stickyCap: "Smakprovet försvinner · 3 platser kvar",
      stickyCapShort: "3 platser kvar",
      stickyBtn: "Lås upp",
      offerLabel: "TIDSBEGRÄNSAT ERBJUDANDE",
      unlockPrefix: "Lås upp hela låten till ",
      unlockSuffix: "",
      offerSub: "Rabatten gäller bara nu",
      expressTitle: "Din låt inom 30 minuter",
      expressB1: "Hela låten i din inkorg inom 30 minuter",
      expressB2: "Högsta prioritet i studion",
      expressB3: "Engångserbjudande",
      popularBadge: "MEST VALD",
      standardTitle: "Din låt inom 48 timmar",
      standardDesc: "Samma låt, levererad inom 48 timmar",
      streamingTitle: "Din låt på Spotify och Apple Music",
      streamingDesc: "Lägg till den i dina vardagliga spellistor.",
      lyricsPrefix: "Låttexten till",
      lyricsSuffix: ", att spara för alltid",
      lyricsDesc: "Utskrivbar, med namnet och låtens omslag. Att spara, ge bort eller rama in.",
      photoError: "Uppladdningen misslyckades, försök igen.",
      photoFormat: "Det här bildformatet stöds inte. Prova en JPG eller PNG.",
      ctaMain: "Lås upp hela låten",
      trust1: "Direkt tillgång",
      trust2: "Din för alltid",
      guaranteeTitle: "Nöjd eller pengarna tillbaka",
      guaranteeBody: "Obegränsat med ändringar tills du älskar låten, eller alla pengar tillbaka.",
      socialProof: "Över 20 000 låtar levererade med kärlek",
      includedTitle: "Det här ingår",
      inc1Title: "Direkt tillgång",
      inc1Desc: "Tillgänglig direkt efter köpet",
      inc2Title: "Online för alltid",
      inc2Desc: "På alla enheter, när du vill",
      inc3Title: "Ladda ner när du vill",
      inc3Desc: "Ljudfil i hög kvalitet",
      inc4Title: "Gratis ändringar",
      inc4Desc: "Tills du är nöjd",
      faqTitle: "Vanliga frågor",
      faqQ1: "Vad händer direkt efter betalningen?",
      faqA1: "Din låt går i produktion inom en minut. Studion spelar in hela låten i HD-studiokvalitet, med sång, instrument och mix. Sedan får du ett mejl med den privata länken till din låt: inom 30 minuter med expressleverans, inom 48 timmar med standardleverans.",
      faqQ2: "Hur ger jag bort låten så att stunden blir som bäst?",
      faqA2: "I bilen, tillsammans i soffan, eller inför alla om det är till en fest. En lugn plats, en högtalare (en liten fungerar fint) eller högtalaren i en nyare mobil. Säg bara: ”lyssna”.",
      faqQ3: "Hur får jag låten?",
      faqA3: "En privat sida som är helt din, med låten, texten och fotot. Filen kan du ladda ner därifrån när du vill.",
      faqQ4: "Kan jag be om ändringar?",
      faqA4: "Ja, så många gånger som behövs och utan kostnad i 7 dagar. Ett namn, en rad, en hel vers: vi ändrar och skickar den nya versionen till dig.",
      faqQ5: "Är betalningen säker?",
      faqA5: "Ja. Alla betalningar hanteras av Shopify med kryptering på banknivå. Vi sparar aldrig dina kortuppgifter.",
      loading: "Ditt smakprov laddas…",
      errorTitle: "Smakprovet hittades inte",
      errorBody: "Länken du använde är ogiltig eller har gått ut.",
      errorCta: "Börja om",
      pendingTitle: "Ditt smakprov skapas…",
      pendingBody: "Vi komponerar din personliga låt. Du får ett mejl så fort den är klar.",
      pendingHint: "🎧 Ditt smakprov dyker upp här så fort det är klart.",
      pendingLate: "Din låt tar lite längre tid än väntat. Ingen fara: så fort den är klar får du den via mejl, och den här sidan uppdateras.",
      cartError: "Något gick fel. Kontrollera din anslutning och försök igen.",
      saveLabel: "Spara",
      propRecipient: "Till vem",
      propRecipientName: "Mottagarens förnamn",
      propStyle: "Musikstil",
      propOccasion: "Tillfälle",
      propPreviewUrl: "Lyssnat smakprov",
      propStylePrompt: "Stilbeskrivning",
      propLyrics: "Låttext"
    },
    da: {
      heroPrefix: "Opdag den personlige sang til ",
      heroSuffix: "",
      playLabel: "Tryk for at lytte",
      pauseLabel: "Pause",
      previewLabel: "⏱ Smagsprøve",
      durationLabel: "Smagsprøve på 90 sek.",
      lockedLabel: "Hele sangen er låst",
      emotionText: "Forestil dig udtrykket i ansigtet på <strong>{name}</strong>, når sangen lyder 😍. En gave at værne om for altid.",
      capacityMain: "Kun 3 ledige pladser de næste 24 timer",
      capacitySub: "For at holde kvaliteten høj laver vores studie kun et begrænset antal sange om dagen.",
      expiryLabel: "Din smagsprøve er online i endnu",
      expirySub: "Vores studie gemmer ikke smagsprøver i mere end 24 timer. Bestil din sang nu, og <strong>få ubegrænsede ændringer, indtil du er helt glad for den.</strong>",
      studioNoteLabel: "✍️ En hilsen fra vores studie",
      studioNoteSign: "Sofie, sangskriver",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-sofie.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> er heldig at have dig. Tak, fordi du betror os denne sang. Vi har lavet den med stor omhu og håber virkelig, at du vil elske den.",
      stickyCap: "Smagsprøven forsvinder · 3 pladser tilbage",
      stickyCapShort: "3 pladser tilbage",
      stickyBtn: "Lås op",
      offerLabel: "BEGRÆNSET TILBUD",
      unlockPrefix: "Lås nu op for hele sangen til ",
      unlockSuffix: "",
      offerSub: "Rabatten gælder kun nu",
      expressTitle: "Din sang på 30 minutter",
      expressB1: "Hele sangen i din indbakke på 30 minutter",
      expressB2: "Førsteprioritet i studiet",
      expressB3: "Engangstilbud",
      popularBadge: "MEST VALGT",
      standardTitle: "Din sang inden for 48 timer",
      standardDesc: "Samme sang, leveret inden for 48 timer",
      streamingTitle: "Din sang på Spotify og Apple Music",
      streamingDesc: "Sæt den på dine daglige playlister.",
      lyricsPrefix: "Gem sangteksten til",
      lyricsSuffix: " for altid",
      lyricsDesc: "Til at printe, med navnet og sangens cover. Gem den, giv den væk, eller sæt den i ramme.",
      photoError: "Upload mislykkedes, prøv igen.",
      photoFormat: "Dette billedformat understøttes ikke. Prøv en JPG eller PNG.",
      ctaMain: "Lås op for hele sangen",
      trust1: "Adgang med det samme",
      trust2: "Din for altid",
      guaranteeTitle: "Tilfreds eller pengene tilbage",
      guaranteeBody: "Ubegrænsede ændringer, indtil du elsker sangen, eller alle pengene tilbage.",
      socialProof: "Over 20.000 sange leveret med kærlighed",
      includedTitle: "Det får du",
      inc1Title: "Adgang med det samme",
      inc1Desc: "Klar lige efter købet",
      inc2Title: "Online for altid",
      inc2Desc: "På alle enheder, når du vil",
      inc3Title: "Download når som helst",
      inc3Desc: "Lydfil i høj kvalitet",
      inc4Title: "Gratis ændringer",
      inc4Desc: "Indtil du er glad for den",
      faqTitle: "Ofte stillede spørgsmål",
      faqQ1: "Hvad sker der lige efter betalingen?",
      faqA1: "Din sang går i produktion inden for et minut. Studiet indspiller den i fuld længde, i HD-studiekvalitet, med vokal, instrumenter og mix. Derefter får du en mail med det private link til din sang: inden for 30 minutter med ekspreslevering, inden for 48 timer med standardlevering.",
      faqQ2: "Hvordan giver jeg den, så øjeblikket virkelig rammer?",
      faqA2: "I bilen, sammen i sofaen eller foran alle, hvis det er til en fest. Et roligt sted, en højttaler (en lille en er helt fin) eller højttaleren på en nyere telefon. Sig bare: »lyt lige«.",
      faqQ3: "Hvordan modtager jeg sangen?",
      faqA3: "En privat side, der er helt din, med sangen, teksten og billedet. Du kan downloade filen derfra, når du vil.",
      faqQ4: "Kan jeg bede om ændringer?",
      faqA4: "Ja, så mange gange det er nødvendigt og gratis i 7 dage. Et navn, en linje, et helt vers: vi retter det og sender dig den nye version.",
      faqQ5: "Er betalingen sikker?",
      faqA5: "Ja. Alle betalinger håndteres af Shopify med kryptering på bankniveau. Vi gemmer aldrig dine kortoplysninger.",
      loading: "Din smagsprøve indlæses…",
      errorTitle: "Smagsprøven blev ikke fundet",
      errorBody: "Linket, du brugte, er ugyldigt eller udløbet.",
      errorCta: "Start forfra",
      pendingTitle: "Din smagsprøve bliver lavet…",
      pendingBody: "Vi komponerer din personlige sang. Du får en mail, så snart den er klar.",
      pendingHint: "🎧 Din smagsprøve dukker op her, så snart den er klar.",
      pendingLate: "Din sang tager lidt længere tid end forventet. Bare rolig: så snart den er klar, får du den på mail, og denne side bliver opdateret.",
      cartError: "Noget gik galt. Tjek din forbindelse, og prøv igen.",
      saveLabel: "Spar",
      propRecipient: "Til hvem",
      propRecipientName: "Modtagerens fornavn",
      propStyle: "Musikstil",
      propOccasion: "Anledning",
      propPreviewUrl: "Hørt smagsprøve",
      propStylePrompt: "Stilbeskrivelse",
      propLyrics: "Sangtekst"
    },
    nb: {
      heroPrefix: "Oppdag den personlige sangen til ",
      heroSuffix: "",
      playLabel: "Trykk for å lytte",
      pauseLabel: "Pause",
      previewLabel: "⏱ Smakebit",
      durationLabel: "Smakebit på 90 sek",
      lockedLabel: "Hele sangen er låst",
      emotionText: "Se for deg ansiktet til <strong>{name}</strong> når denne sangen spilles 😍. En gave å ta vare på for alltid.",
      capacityMain: "Bare 3 ledige plasser de neste 24 timene",
      capacitySub: "For å holde kvaliteten høy lager studioet vårt bare et begrenset antall sanger hver dag.",
      expiryLabel: "Smakebiten din ligger ute i",
      expirySub: "Studioet vårt tar ikke vare på smakebiter lenger enn 24 timer. Bestill sangen din nå og <strong>få ubegrensede endringer til du er helt fornøyd.</strong>",
      studioNoteLabel: "✍️ En hilsen fra studioet vårt",
      studioNoteSign: "Ingrid, låtskriver",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-ingrid.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> er heldig som har deg. Takk for at du betror oss denne sangen. Vi har laget den med stor omhu og håper virkelig at du blir glad i den.",
      stickyCap: "Smakebiten forsvinner · 3 plasser igjen",
      stickyCapShort: "3 plasser igjen",
      stickyBtn: "Lås opp",
      offerLabel: "TIDSBEGRENSET TILBUD",
      unlockPrefix: "Lås opp hele sangen til ",
      unlockSuffix: "",
      offerSub: "Rabatten gjelder bare nå",
      expressTitle: "Sangen din innen 30 minutter",
      expressB1: "Hele sangen i innboksen din innen 30 minutter",
      expressB2: "Førsteprioritet i studioet",
      expressB3: "Engangstilbud",
      popularBadge: "MEST VALGT",
      standardTitle: "Sangen din innen 48 timer",
      standardDesc: "Samme sang, levert innen 48 timer",
      streamingTitle: "Sangen din på Spotify og Apple Music",
      streamingDesc: "Legg den til i spillelistene du hører på hver dag.",
      lyricsPrefix: "Ta vare på sangteksten til",
      lyricsSuffix: " for alltid",
      lyricsDesc: "Til å skrive ut, med navnet og coveret til sangen. Til å ta vare på, gi bort eller ramme inn.",
      photoError: "Opplastingen mislyktes, prøv igjen.",
      photoFormat: "Dette bildeformatet støttes ikke. Prøv JPG eller PNG.",
      ctaMain: "Lås opp hele sangen",
      trust1: "Umiddelbar tilgang",
      trust2: "Din for alltid",
      guaranteeTitle: "Fornøyd eller pengene tilbake",
      guaranteeBody: "Ubegrensede endringer til du elsker sangen, ellers får du alle pengene tilbake.",
      socialProof: "Over 20 000 sanger levert med kjærlighet",
      includedTitle: "Dette får du",
      inc1Title: "Umiddelbar tilgang",
      inc1Desc: "Tilgjengelig rett etter kjøpet",
      inc2Title: "Lagret for alltid",
      inc2Desc: "På alle enheter, når du vil",
      inc3Title: "Last ned når du vil",
      inc3Desc: "Lydfil i høy kvalitet",
      inc4Title: "Gratis endringer",
      inc4Desc: "Til du er helt fornøyd",
      faqTitle: "Ofte stilte spørsmål",
      faqQ1: "Hva skjer rett etter betalingen?",
      faqA1: "Sangen din går i produksjon i løpet av et minutt. Studioet spiller den inn i sin helhet, i HD-studiokvalitet, med vokal, instrumenter og miks. Deretter får du en e-post med den private lenken til sangen din: innen 30 minutter med ekspresslevering, innen 48 timer med standardlevering.",
      faqQ2: "Hvordan gir jeg den bort så øyeblikket virkelig treffer?",
      faqA2: "I bilen, sammen i sofaen, eller foran alle hvis det er til en fest. Et rolig sted, en høyttaler (en liten en holder fint) eller høyttaleren på en nyere telefon. Bare si: «hør her».",
      faqQ3: "Hvordan får jeg sangen?",
      faqA3: "En privat side som er helt din, med sangen, teksten og bildet. Der kan du laste ned filen når du vil.",
      faqQ4: "Kan jeg be om endringer?",
      faqA4: "Ja, så mange ganger du trenger, og gratis i 7 dager. Et navn, en linje, et helt vers: vi endrer det og sender deg den nye versjonen.",
      faqQ5: "Er betalingen trygg?",
      faqA5: "Ja. Alle betalinger behandles av Shopify med kryptering på banknivå. Vi lagrer aldri kortopplysningene dine.",
      loading: "Smakebiten din lastes inn…",
      errorTitle: "Fant ikke smakebiten",
      errorBody: "Lenken du brukte er ugyldig eller utløpt.",
      errorCta: "Begynn på nytt",
      pendingTitle: "Smakebiten din lages…",
      pendingBody: "Vi komponerer den personlige sangen din. Du får en e-post så snart den er klar.",
      pendingHint: "🎧 Smakebiten din dukker opp her så snart den er klar.",
      pendingLate: "Sangen din tar litt lengre tid enn ventet. Ingen fare: så snart den er klar, får du den på e-post, og denne siden blir oppdatert.",
      cartError: "Noe gikk galt. Sjekk tilkoblingen din og prøv igjen.",
      saveLabel: "Spar",
      propRecipient: "Til hvem",
      propRecipientName: "Mottakerens fornavn",
      propStyle: "Musikkstil",
      propOccasion: "Anledning",
      propPreviewUrl: "Hørt smakebit",
      propStylePrompt: "Stilbeskrivelse",
      propLyrics: "Sangtekst"
    },
    pt: {
      heroPrefix: "Descubra a canção personalizada para ",
      heroSuffix: "",
      playLabel: "Toque para ouvir",
      pauseLabel: "Pausa",
      previewLabel: "⏱ Amostra",
      durationLabel: "Amostra de 90 s",
      lockedLabel: "Canção completa bloqueada",
      emotionText: "Imagine o olhar de <strong>{name}</strong> ao ouvir esta canção 😍. Um presente para guardar para sempre.",
      capacityMain: "Restam apenas 3 vagas nas próximas 24 horas",
      capacitySub: "Para manter a qualidade, o nosso estúdio produz apenas um número limitado de canções por dia.",
      expiryLabel: "A sua amostra fica disponível durante",
      expirySub: "O nosso estúdio não guarda amostras durante mais de 24 horas. Encomende já a sua canção e <strong>conte com alterações ilimitadas até adorar o resultado.</strong>",
      studioNoteLabel: "✍️ Uma palavra do nosso estúdio",
      studioNoteSign: "Inês, compositora",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-ines.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> tem muita sorte em ter alguém assim por perto. Obrigada por nos confiar esta canção. Fizemo-la com muito cuidado e esperamos de coração que goste.",
      stickyCap: "A amostra expira · restam 3 vagas",
      stickyCapShort: "Restam 3 vagas",
      stickyBtn: "Desbloquear",
      offerLabel: "OFERTA LIMITADA",
      unlockPrefix: "Desbloqueie já a canção completa para ",
      unlockSuffix: "",
      offerSub: "Desconto válido apenas agora",
      expressTitle: "A sua canção em 30 minutos",
      expressB1: "Canção completa no seu e-mail em 30 minutos",
      expressB2: "Prioridade absoluta no estúdio",
      expressB3: "Oferta única",
      popularBadge: "A MAIS ESCOLHIDA",
      standardTitle: "A sua canção em 48 horas",
      standardDesc: "A mesma canção, entregue no prazo de 48 horas",
      streamingTitle: "A sua canção no Spotify e no Apple Music",
      streamingDesc: "Junte-a às suas playlists do dia a dia.",
      lyricsPrefix: "A letra da canção de",
      lyricsSuffix: ", para guardar para sempre",
      lyricsDesc: "Para imprimir, com o nome e a capa da canção. Para guardar, oferecer ou emoldurar.",
      photoError: "O envio falhou. Tente novamente.",
      photoFormat: "Este formato de foto não é suportado. Experimente JPG ou PNG.",
      ctaMain: "Desbloquear a canção completa",
      trust1: "Acesso imediato",
      trust2: "Sua para sempre",
      guaranteeTitle: "Garantia de reembolso",
      guaranteeBody: "Alterações ilimitadas até adorar a canção, ou o reembolso total.",
      socialProof: "Mais de 20.000 canções entregues com carinho",
      includedTitle: "O que está incluído",
      inc1Title: "Acesso imediato",
      inc1Desc: "Disponível logo após a compra",
      inc2Title: "Online para sempre",
      inc2Desc: "Em qualquer dispositivo, quando quiser",
      inc3Title: "Descarregue quando quiser",
      inc3Desc: "Ficheiro áudio de alta qualidade",
      inc4Title: "Alterações gratuitas",
      inc4Desc: "Até adorar o resultado",
      faqTitle: "Perguntas frequentes",
      faqQ1: "O que acontece logo após o pagamento?",
      faqA1: "A sua canção entra em produção no espaço de um minuto. O estúdio grava-a na íntegra, com qualidade de estúdio HD, voz, instrumentos e mistura. Depois, recebe um e-mail com o link privado para a sua canção: em 30 minutos com a entrega expresso, no prazo de 48 horas com a entrega normal.",
      faqQ2: "Como oferecê-la para que o momento fique na memória?",
      faqA2: "No carro, no sofá a dois, ou diante de todos se for para uma festa. Um sítio sossegado, uma coluna (mesmo pequena serve) ou o altifalante de um telemóvel recente. Basta dizer: «ouve só».",
      faqQ3: "Como recebo a canção?",
      faqA3: "Uma página privada só sua, com a canção, a letra e a foto. Pode descarregar o ficheiro a partir dessa página sempre que quiser.",
      faqQ4: "Posso pedir alterações?",
      faqA4: "Sim, as vezes que forem precisas e sem custos durante 7 dias. Um nome, uma frase, um verso inteiro: refazemos e enviamos-lhe a nova versão.",
      faqQ5: "O pagamento é seguro?",
      faqA5: "Sim. Todos os pagamentos são processados pela Shopify com encriptação de nível bancário. Nunca guardamos os dados do seu cartão.",
      loading: "A carregar a sua amostra…",
      errorTitle: "Amostra não encontrada",
      errorBody: "O link utilizado é inválido ou expirou.",
      errorCta: "Recomeçar",
      pendingTitle: "A sua amostra está a ser criada…",
      pendingBody: "Estamos a compor a sua canção personalizada. Vai receber um e-mail assim que estiver pronta.",
      pendingHint: "🎧 A sua amostra vai aparecer aqui assim que estiver pronta.",
      pendingLate: "A sua canção está a demorar um pouco mais do que o previsto. Não se preocupe: assim que estiver pronta, recebe-a por e-mail e esta página é atualizada.",
      cartError: "Algo correu mal. Verifique a sua ligação e tente novamente.",
      saveLabel: "Poupe",
      propRecipient: "Para quem",
      propRecipientName: "Nome de quem recebe",
      propStyle: "Estilo musical",
      propOccasion: "Ocasião",
      propPreviewUrl: "Amostra ouvida",
      propStylePrompt: "Descrição do estilo",
      propLyrics: "Letra"
    },
    fi: {
      heroPrefix: "Kuuntele henkilökohtainen laulu, jonka saa ",
      heroSuffix: "",
      playLabel: "Napauta ja kuuntele",
      pauseLabel: "Tauko",
      previewLabel: "⏱ Näyte",
      durationLabel: "90 sekunnin näyte",
      lockedLabel: "Koko laulu on lukittu",
      emotionText: "Kuvittele, miltä <strong>{name}</strong> näyttää kuullessaan tämän laulun 😍. Lahja, jota vaalitaan aina.",
      capacityMain: "Vain 3 paikkaa vapaana seuraavan 24 tunnin aikana",
      capacitySub: "Jotta laatu pysyy korkeana, studiomme tekee päivässä vain rajallisen määrän lauluja.",
      expiryLabel: "Näytteesi on kuunneltavissa vielä",
      expirySub: "Studiomme ei säilytä näytteitä 24 tuntia pidempään. Tilaa laulusi nyt ja <strong>saat rajattomasti muutoksia, kunnes olet täysin tyytyväinen.</strong>",
      studioNoteLabel: "✍️ Terveiset studioltamme",
      studioNoteSign: "Aino, lauluntekijä",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-aino.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> on onnekas, kun hänellä on sinut. Kiitos, että annoit tämän laulun meidän tehtäväksemme. Teimme sen suurella huolella ja toivomme sydämestämme, että rakastut siihen.",
      stickyCap: "Näyte katoaa · 3 paikkaa jäljellä",
      stickyCapShort: "3 paikkaa jäljellä",
      stickyBtn: "Avaa",
      offerLabel: "RAJOITETTU TARJOUS",
      unlockPrefix: "Avaa nyt koko laulu, jonka saa ",
      unlockSuffix: "",
      offerSub: "Alennus voimassa vain nyt",
      expressTitle: "Laulusi 30 minuutissa",
      expressB1: "Koko laulu sähköpostiisi 30 minuutissa",
      expressB2: "Ehdoton etusija studiossa",
      expressB3: "Kertaluonteinen tarjous",
      popularBadge: "SUOSITUIN",
      standardTitle: "Laulusi 48 tunnissa",
      standardDesc: "Sama laulu, toimitettuna 48 tunnin kuluessa",
      streamingTitle: "Laulusi Spotifyssa ja Apple Musicissa",
      streamingDesc: "Lisää se arjen soittolistoillesi.",
      lyricsPrefix: "Sanat, joissa soi nimi",
      lyricsSuffix: ", ikuisesti tallessa",
      lyricsDesc: "Tulostettava versio, jossa on nimi ja laulun kansikuva. Säilytettäväksi, lahjaksi tai kehystettäväksi.",
      photoError: "Lähetys epäonnistui, yritä uudelleen.",
      photoFormat: "Tätä kuvamuotoa ei tueta. Kokeile JPG- tai PNG-kuvaa.",
      ctaMain: "Avaa koko laulu",
      trust1: "Heti käytössä",
      trust2: "Ikuisesti sinun",
      guaranteeTitle: "Rahat takaisin -takuu",
      guaranteeBody: "Rajattomasti muutoksia, kunnes rakastat laulua, tai kaikki rahat takaisin.",
      socialProof: "Yli 20 000 laulua toimitettu rakkaudella",
      includedTitle: "Mitä saat",
      inc1Title: "Heti käytössä",
      inc1Desc: "Avautuu heti oston jälkeen",
      inc2Title: "Ikuisesti verkossa",
      inc2Desc: "Millä laitteella tahansa, milloin vain",
      inc3Title: "Ladattavissa milloin vain",
      inc3Desc: "Korkealaatuinen äänitiedosto",
      inc4Title: "Maksuttomat muutokset",
      inc4Desc: "Kunnes olet tyytyväinen",
      faqTitle: "Usein kysyttyä",
      faqQ1: "Mitä tapahtuu heti maksun jälkeen?",
      faqA1: "Laulusi menee tuotantoon minuutin sisällä. Studio äänittää sen kokonaan HD-studiolaadulla: laulu, soittimet ja miksaus. Sen jälkeen saat sähköpostin, jossa on yksityinen linkki lauluusi: 30 minuutissa pikatoimituksella, 48 tunnin kuluessa vakiotoimituksella.",
      faqQ2: "Miten annan sen niin, että hetki todella koskettaa?",
      faqA2: "Autossa, kahden kesken sohvalla tai kaikkien edessä, jos kyse on juhlasta. Rauhallinen paikka, kaiutin (pienikin käy) tai uudehkon puhelimen kaiutin. Sano vain: ”kuuntele”.",
      faqQ3: "Miten saan laulun?",
      faqA3: "Saat oman yksityisen sivun, jossa on laulu, sanat ja kuva. Tiedoston voit ladata sivulta milloin vain.",
      faqQ4: "Voinko pyytää muutoksia?",
      faqA4: "Kyllä, niin monta kertaa kuin tarvitset ja maksutta 7 päivän ajan. Nimi, säe, kokonainen säkeistö: muokkaamme sen ja lähetämme sinulle uuden version.",
      faqQ5: "Onko maksaminen turvallista?",
      faqA5: "Kyllä. Kaikki maksut käsittelee Shopify pankkitason salauksella. Emme koskaan tallenna korttitietojasi.",
      loading: "Näytettäsi ladataan…",
      errorTitle: "Näytettä ei löytynyt",
      errorBody: "Käyttämäsi linkki on virheellinen tai vanhentunut.",
      errorCta: "Aloita alusta",
      pendingTitle: "Näytettäsi tehdään…",
      pendingBody: "Sävellämme henkilökohtaista lauluasi. Saat sähköpostin heti, kun se on valmis.",
      pendingHint: "🎧 Näytteesi ilmestyy tähän heti, kun se on valmis.",
      pendingLate: "Laulusi valmistuminen kestää vähän odotettua kauemmin. Ei hätää: saat sen sähköpostiisi heti, kun se on valmis, ja tämä sivu päivittyy.",
      cartError: "Jokin meni pieleen. Tarkista yhteytesi ja yritä uudelleen.",
      saveLabel: "Säästä",
      propRecipient: "Kenelle",
      propRecipientName: "Saajan etunimi",
      propStyle: "Musiikkityyli",
      propOccasion: "Tilaisuus",
      propPreviewUrl: "Kuunneltu näyte",
      propStylePrompt: "Tyylikuvaus",
      propLyrics: "Sanat"
    },
    es: {
      heroPrefix: "Descubre la canción personalizada de ",
      heroSuffix: "",
      playLabel: "Toca para escuchar",
      pauseLabel: "Pausa",
      previewLabel: "⏱ Adelanto",
      durationLabel: "Adelanto de 90 s",
      lockedLabel: "Canción completa bloqueada",
      emotionText: "Imagina lo que sentirá <strong>{name}</strong> al escucharla 😍. Un regalo que atesorará para siempre.",
      capacityMain: "Solo quedan 3 plazas en las próximas 24h",
      capacitySub: "Para mantener la calidad, nuestro estudio solo produce un número limitado de canciones al día.",
      expiryLabel: "Tu adelanto sigue disponible durante",
      expirySub: "Nuestro estudio no conserva los adelantos más de 24h. Reserva tu canción ahora y <strong>disfruta de modificaciones ilimitadas hasta que te encante.</strong>",
      studioNoteLabel: "✍️ Unas palabras de nuestro estudio",
      studioNoteSign: "Lucía, compositora",
      studioNoteAvatar: "https://cdn.shopify.com/s/files/1/0905/0718/2411/files/ym-studio-lucia_c607bb57-3369-4127-9c99-e2aba4638410.png?width=96&height=96&crop=center",
      studioNoteFallback: "<strong>{name}</strong> tiene mucha suerte de tenerte. Gracias por confiarnos esta canción. La hemos compuesto con mucho cuidado y esperamos de corazón que te encante.",
      stickyCap: "El adelanto desaparece · 3 plazas restantes",
      stickyCapShort: "3 plazas restantes",
      stickyBtn: "Desbloquear",
      offerLabel: "OFERTA LIMITADA",
      unlockPrefix: "Desbloquea la canción completa de ",
      unlockSuffix: "",
      offerSub: "Descuento válido solo ahora",
      expressTitle: "Tu canción en 30 minutos",
      expressB1: "Canción completa en tu correo en 30 min",
      expressB2: "Prioridad absoluta de estudio",
      expressB3: "Oferta única",
      popularBadge: "MÁS POPULAR",
      standardTitle: "Tu canción en 48 horas",
      standardDesc: "La misma canción, entregada en 48 horas",
      streamingTitle: "Tu canción en Spotify y Apple Music",
      streamingDesc: "Añádela a tus playlists de cada día.",
      lyricsPrefix: "Guarda la letra de",
      lyricsSuffix: " para siempre",
      lyricsDesc: "Imprimible, con su nombre y la portada de la canción. Guárdala, regálala, enmárcala.",
      photoError: "No se pudo enviar, inténtalo de nuevo.",
      photoFormat: "Este formato de foto no es compatible. Prueba con JPG o PNG.",
      ctaMain: "Desbloquear la canción completa",
      trust1: "Acceso instantáneo",
      trust2: "Tuya para siempre",
      guaranteeTitle: "Satisfacción garantizada o te devolvemos el dinero",
      guaranteeBody: "Revisiones ilimitadas hasta que la canción te guste, o reembolso íntegro.",
      socialProof: "Más de 20.000 canciones entregadas con amor",
      includedTitle: "Lo que incluye",
      inc1Title: "Acceso instantáneo",
      inc1Desc: "Desbloqueo inmediato tras la compra",
      inc2Title: "Alojada para siempre",
      inc2Desc: "Acceso en cualquier dispositivo",
      inc3Title: "Descarga ilimitada",
      inc3Desc: "Archivo de audio en alta calidad",
      inc4Title: "Revisiones gratuitas",
      inc4Desc: "Hasta que te encante",
      faqTitle: "Preguntas frecuentes",
      faqQ1: "¿Qué pasa justo después del pago?",
      faqA1: "Tu canción entra en producción en el momento. El estudio la graba entera, en calidad de estudio HD, con voz, instrumentos y mezcla. Después recibes un correo con el enlace privado de tu canción: 30 minutos con la entrega exprés, en 48 horas con la entrega clásica.",
      faqQ2: "¿Cómo regalarla para que el momento salga bien?",
      faqA2: "En el coche, en el salón solo vosotros dos, o delante de todos si es para un evento. Un sitio tranquilo, un altavoz aunque sea pequeño, o el altavoz de un teléfono reciente. Di simplemente: «escucha».",
      faqQ3: "¿De qué forma recibo la canción?",
      faqA3: "Una página privada que es tuya, con la canción, la letra y la foto. El archivo se puede descargar desde esa página cuando quieras.",
      faqQ4: "¿Puedo pedir modificaciones?",
      faqA4: "Sí, tantas veces como haga falta y sin coste durante 7 días. Un nombre, una frase, una estrofa entera: la rehacemos y te enviamos la nueva versión.",
      faqQ5: "¿El pago es seguro?",
      faqA5: "Sí. Todos los pagos se procesan con Shopify con cifrado bancario. Nunca guardamos los datos de tu tarjeta.",
      loading: "Cargando tu adelanto…",
      errorTitle: "Adelanto no encontrado",
      errorBody: "El enlace que has utilizado no es válido o ha expirado.",
      errorCta: "Empezar de nuevo",
      pendingTitle: "Tu adelanto se está preparando…",
      pendingBody: "Estamos componiendo tu canción personalizada. Recibirás un correo en cuanto esté lista.",
      pendingHint: "🎧 Tu adelanto aparecerá aquí en cuanto esté listo.",
      pendingLate: "Tu canción está tardando un poco más de lo previsto. Tranquilo: en cuanto esté lista la recibirás por correo y esta página se actualizará.",
      cartError: "Ha ocurrido un error. Comprueba tu conexión e inténtalo de nuevo.",
      saveLabel: "Ahorro",
      propRecipient: "Para quién",
      propRecipientName: "Nombre destinatario",
      propStyle: "Estilo musical",
      propOccasion: "Ocasión",
      propPreviewUrl: "Adelanto escuchado",
      propStylePrompt: "Descripción estilo",
      propLyrics: "Letra"
    }
  };

  const listLocale = locale.startsWith('en') ? 'en'
                   : locale.startsWith('de') ? 'de'
                   : locale.startsWith('es') ? 'es'
                   : locale.startsWith('ja') ? 'ja'
                   : locale.startsWith('it') ? 'it'
                   : locale.startsWith('nl') ? 'nl'
                   : locale.startsWith('sv') ? 'sv'
                   : locale.startsWith('da') ? 'da'
                   : locale.startsWith('nb') ? 'nb'
                   : locale.startsWith('pt') ? 'pt'
                   : locale.startsWith('fi') ? 'fi'
                   : 'fr';
  const t = I18N[listLocale] || I18N.fr;

  // Formate un montant Shopify (ex. "39.95") avec les conventions de la langue :
  // 39,95 € en fr et de, $39.95 en en. Repli sur la chaine deja formatee par Liquid.
  const MONEY_TAG = { fr: 'fr-FR', en: 'en-US', de: 'de-DE', es: 'es-ES', ja: 'ja-JP', it: 'it-IT', nl: 'nl-NL', sv: 'sv-SE', da: 'da-DK', nb: 'nb-NO', pt: 'pt-PT', fi: 'fi-FI' };
  function money(amount, fallback) {
    const n = parseFloat(String(amount || '').replace(',', '.')) / 100;  // Liquid renvoie des centimes
    if (!CURRENCY || !isFinite(n)) return fallback || '';
    try {
      // 28/09/2026 : en euros le signe va apres le montant dans toutes les langues (decision du 18/09) ;
      // en anglais Intl le mettait devant (« €55.95 »), on rend donc « 55.95 € » a la main.
      if (CURRENCY === 'EUR' && listLocale === 'en') {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + ' €';
      }
      // 21/10 : meme regle pour le neerlandais (Intl nl-NL met le signe euro devant le montant).
      if (CURRENCY === 'EUR' && listLocale === 'nl') {
        return new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + ' €';
      }
      return new Intl.NumberFormat(MONEY_TAG[listLocale] || 'fr-FR', { style: 'currency', currency: CURRENCY }).format(n);
    } catch (e) { return fallback || ''; }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ============================================================
  //  DOM refs
  // ============================================================
  const els = {};
  root.querySelectorAll('[data-ym]').forEach(el => {
    const key = el.getAttribute('data-ym');
    if (!els[key]) els[key] = el;
  });

  // Multiple recipient-name spans
  const recipientNameEls = root.querySelectorAll('[data-ym="recipient-name"], [data-ym="recipient-name-2"], [data-ym="recipient-name-3"]');

  function showState(name) {
    ['loading', 'error', 'pending', 'ready'].forEach(k => {
      if (els[k]) els[k].hidden = (k !== name);
    });
    // App blocks slot only on ready
    const after = root.querySelector('[data-ym="after-cta-slot"]');
    if (after) after.hidden = (name !== 'ready');
    const faqSlot = root.querySelector('[data-ym="faq-slot"]');
    if (faqSlot) faqSlot.hidden = (name !== 'ready');
  }

  // ============================================================
  //  Aucune mesure maison sur cette page. Regle posee le 22/09/2026 : on n envoie
  //  aux regies que les evenements standards du canal Shopify, le Lead du
  //  questionnaire et le ViewContent des deux premieres pages de tunnel. Les trois
  //  evenements PreviewLanded / PreviewPlayed / PreviewPhotoAdded ont ete retires,
  //  avec la fonction qui les portait. Ne pas la remettre.
  // ============================================================

  // ============================================================
  //  Apply localized strings
  // ============================================================
  function setText(key, value) {
    const el = root.querySelector('[data-ym="i18n-' + key + '"]');
    if (el) el.textContent = value;
  }

  function applyI18n() {
    setText('loading', t.loading);
    setText('error-title', t.errorTitle);
    setText('error-body', t.errorBody);
    setText('error-cta', t.errorCta);
    setText('pending-title', t.pendingTitle);
    setText('pending-body', t.pendingBody);
    setText('pending-hint', t.pendingHint);
    setText('hero-prefix', t.heroPrefix);
    setText('hero-suffix', t.heroSuffix);
    setText('preview-label', t.previewLabel);
    setText('locked-label', t.lockedLabel);
    setText('offer-label', t.offerLabel);
    setText('unlock-prefix', t.unlockPrefix);
    setText('unlock-suffix', t.unlockSuffix);
    setText('offer-sub', t.offerSub);
    setText('express-title', t.expressTitle);
    setText('express-b1', t.expressB1);
    setText('express-b2', t.expressB2);
    setText('express-b3', t.expressB3);
    setText('popular-badge', t.popularBadge);
    setText('standard-title', t.standardTitle);
    setText('standard-desc', t.standardDesc);
    setText('streaming-title', t.streamingTitle);
    setText('streaming-desc', t.streamingDesc);
    setText('lyrics-prefix', t.lyricsPrefix);
    setText('lyrics-suffix', t.lyricsSuffix);
    setText('lyrics-desc', t.lyricsDesc);
    setText('cta-main', t.ctaMain);
    setText('trust-1', t.trust1);
    setText('trust-2', t.trust2);
    setText('guarantee-title', t.guaranteeTitle);
    setText('guarantee-body', t.guaranteeBody);
    setText('social-proof', t.socialProof);
    setText('included-title', t.includedTitle);
    setText('inc-1-title', t.inc1Title);
    setText('inc-1-desc', t.inc1Desc);
    setText('inc-2-title', t.inc2Title);
    setText('inc-2-desc', t.inc2Desc);
    setText('inc-3-title', t.inc3Title);
    setText('inc-3-desc', t.inc3Desc);
    setText('inc-4-title', t.inc4Title);
    setText('inc-4-desc', t.inc4Desc);
    setText('faq-title', t.faqTitle);
    setText('faq-q1', t.faqQ1);
    setText('faq-a1', t.faqA1);
    setText('faq-q2', t.faqQ2);
    setText('faq-a2', t.faqA2);
    setText('faq-q3', t.faqQ3);
    setText('faq-a3', t.faqA3);
    setText('faq-q4', t.faqQ4);
    setText('faq-a4', t.faqA4);
    setText('faq-q5', t.faqQ5);
    setText('faq-a5', t.faqA5);

    // Urgency layer (capacity strip · expiry card · sticky bar)
    setText('capacity-main', t.capacityMain);
    setText('capacity-sub', t.capacitySub);
    setText('expiry-label', t.expiryLabel);
    const expSubEl = root.querySelector('[data-ym="i18n-expiry-sub"]');
    if (expSubEl) expSubEl.innerHTML = t.expirySub; // contient <strong>
    setText('studio-note-label', t.studioNoteLabel);
    setText('studio-note-sign', t.studioNoteSign);
    var noteAv = document.querySelector('[data-ym="studio-note-avatar"]'); if (noteAv && t.studioNoteAvatar) noteAv.src = t.studioNoteAvatar;
    setText('sticky-btn', t.stickyBtn);
    const stickyCapEl = root.querySelector('[data-ym="sticky-cap"]');
    if (stickyCapEl) stickyCapEl.textContent = t.stickyCap;

    // Prices — viennent de Shopify Liquid (déjà localisés en bonne devise)
    const expressPriceEl = root.querySelector('[data-ym="express-price"]');
    const expressCompareEl = root.querySelector('[data-ym="express-compare"]');
    const expressSaveEl = root.querySelector('[data-ym="express-save"]');
    const standardPriceEl = root.querySelector('[data-ym="standard-price"]');
    const standardCompareEl = root.querySelector('[data-ym="standard-compare"]');
    const streamingPriceEl = root.querySelector('[data-ym="streaming-price"]');

    if (expressPriceEl) expressPriceEl.textContent = money(VARIANTS.express.amount, VARIANTS.express.price);
    if (expressCompareEl) expressCompareEl.textContent = money(VARIANTS.express.compareAmount, VARIANTS.express.compare);
    if (expressSaveEl && VARIANTS.express.compare) {
      expressSaveEl.textContent = t.saveLabel;
    }
    if (standardPriceEl) standardPriceEl.textContent = money(VARIANTS.standard.amount, VARIANTS.standard.price);
    if (standardCompareEl) standardCompareEl.textContent = money(VARIANTS.standard.compareAmount, VARIANTS.standard.compare);
    if (streamingPriceEl) streamingPriceEl.textContent = (VARIANTS.streaming.id ? '+ ' + money(VARIANTS.streaming.amount, VARIANTS.streaming.price) : '');
    const lyricsPriceEl = root.querySelector('[data-ym="lyrics-price"]');
    if (lyricsPriceEl) lyricsPriceEl.textContent = (VARIANTS.lyrics.id ? '+ ' + money(VARIANTS.lyrics.amount, VARIANTS.lyrics.price) : '');

    // Play label
    const playLabel = root.querySelector('[data-ym="play-label"]');
    if (playLabel) playLabel.textContent = t.playLabel;

    // Duration label (60s preview) — uses bare data-ym, not i18n- prefix
    const durEl = root.querySelector('[data-ym="duration-label"]');
    if (durEl) durEl.textContent = t.durationLabel;
  }
  applyI18n();


  // ============================================================
  //  Photo du destinataire : envoyee pendant l attente, affichee sur la chanson.
  //  Le fichier part directement du navigateur vers Shopify ; Make ne fait que
  //  demander la cible puis rattacher le fichier au client de l extrait.
  // ============================================================
  // Au rechargement, la photo deja envoyee revient de l API : on remet le bloc dans son
  // etat "photo ajoutee" au lieu de reproposer le bouton comme si rien n avait ete fait.
  // Il y a un bloc par ecran, celui de l attente et celui de l ecoute : on les met
  // tous les deux dans l etat "photo ajoutee", sinon celui qu on n a pas touche
  // redemanderait une photo deja envoyee.
  // Une photo est la : elle se suffit. On ne la redemande plus, et c est elle qu on
  // touche pour la changer. Sur l ecran d ecoute la couverture la montre deja en grand,
  // donc le bloc disparait ; sur l ecran d attente il n y a pas de couverture, le bloc
  // reste mais reduit a la photo seule.
  const ecranPret = root.querySelector('[data-ym="ready"]');
  function restorePhoto(url) {
    if (!url) return;
    root.querySelectorAll('[data-ym="photo-block"]').forEach(function (bloc) {
      const thumb = bloc.querySelector('[data-ym="photo-thumb"]');
      if (thumb) thumb.src = url;
      const load = bloc.querySelector('[data-ym="photo-loading"]');
      const err = bloc.querySelector('[data-ym="photo-error"]');
      const label = bloc.querySelector('.ym-photo__btn');
      const done = bloc.querySelector('[data-ym="photo-done"]');
      if (load) load.hidden = true;
      if (err) err.hidden = true;
      if (label) label.hidden = true;
      if (done) done.hidden = false;
      bloc.classList.add('ym-photo--seule');
      if (ecranPret && ecranPret.contains(bloc)) bloc.hidden = true;
    });
    showCover(url);
  }

  // Toucher la photo, ou la vignette, rouvre le selecteur.
  function brancherChangementParLaPhoto() {
    const ouvrir = function (bloc) {
      const input = bloc && bloc.querySelector('[data-ym="photo-input"]');
      if (input) input.click();
    };
    const img = root.querySelector('[data-ym="cover-img"]');
    if (img && ecranPret) {
      img.style.cursor = 'pointer';
      img.addEventListener('click', function () { ouvrir(ecranPret.querySelector('[data-ym="photo-block"]')); });
    }
    root.querySelectorAll('[data-ym="photo-thumb"]').forEach(function (v) {
      v.style.cursor = 'pointer';
      v.addEventListener('click', function () { ouvrir(v.closest('[data-ym="photo-block"]')); });
    });
  }

  // 14/10 (Thibaut) : on peut retirer sa photo si on change d'avis
  let photoVersion = 0;
  const TXT_RETIRER = { fr: 'Retirer', en: 'Remove', de: 'Entfernen', es: 'Quitar', ja: '削除', it: 'Rimuovi', nl: 'Verwijderen', sv: 'Ta bort', da: 'Fjern', nb: 'Fjern', pt: 'Remover', fi: 'Poista' }[String(listLocale || 'fr').slice(0, 2)] || 'Remove';
  const TXT_CHANGER = { fr: 'Changer', en: 'Change', de: 'Ändern', es: 'Cambiar', ja: '変更', it: 'Cambia', nl: 'Wijzigen', sv: 'Ändra', da: 'Skift', nb: 'Endre', pt: 'Alterar', fi: 'Vaihda' }[String(listLocale || 'fr').slice(0, 2)] || 'Change';
  function retirerPhoto() {
    photoVersion++;
    if (previewData) previewData.photo_url = '';
    try { const k = 'ym_pv_' + token, c = JSON.parse(localStorage.getItem(k) || 'null'); if (c && c.d) { c.d.photo_url = ''; localStorage.setItem(k, JSON.stringify(c)); } } catch (e) {}
    root.querySelectorAll('[data-ym="photo-input"]').forEach(function (i) { i.value = ''; });
    redemanderPhoto();
    if (ecranPret) root.querySelectorAll('[data-ym="photo-block"]').forEach(function (b) { if (ecranPret.contains(b)) b.hidden = false; });
    photoPost({ action: 'remove', token: token }).catch(function () {});
  }
  function boutonsCouverture(box) {
    if (box.querySelector('.ym-cover-acts')) return;
    const acts = document.createElement('div'); acts.className = 'ym-cover-acts';
    // 14/10 (Thibaut) : une simple croix en haut à droite ; changer = toucher la photo
    const rm = document.createElement('button'); rm.type = 'button'; rm.className = 'ym-cover-x'; rm.setAttribute('aria-label', TXT_RETIRER); rm.innerHTML = '&#10005;';
    rm.addEventListener('click', function (e) { e.stopPropagation(); retirerPhoto(); });
    acts.appendChild(rm); box.appendChild(acts);
  }
  function showCover(url) {
    const box = root.querySelector('[data-ym="cover"]');
    const img = root.querySelector('[data-ym="cover-img"]');
    if (!box || !img) return;
    if (!url) { box.hidden = true; return; }
    boutonsCouverture(box);
    img.src = url;
    img.alt = (previewData && previewData.recipient_name) || '';
    box.hidden = false;
  }

  // Redimensionne avant envoi : 1200 px max, JPEG 0.85. Une photo de telephone
  // passe ainsi de plusieurs Mo a quelques centaines de Ko.
  // Decode le plus largement possible : createImageBitmap couvre des formats que <img> refuse
  // (HEIC sur Safari et iOS notamment). Si rien ne decode, on renverra le fichier tel quel.
  function decodeImage(file) {
    if (window.createImageBitmap) {
      return createImageBitmap(file).catch(function () { return decodeWithImg(file); });
    }
    return decodeWithImg(file);
  }
  function decodeWithImg(file) {
    return new Promise(function (resolve, reject) {
      const i = new Image();
      const u = URL.createObjectURL(file);
      i.onload = function () { URL.revokeObjectURL(u); resolve(i); };
      i.onerror = function () { URL.revokeObjectURL(u); reject(new Error('format illisible')); };
      i.src = u;
    });
  }

  function shrink(file) {
    return decodeImage(file).then(function (img) {
      return new Promise(function (resolve, reject) {
        const max = 1200;
        let w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
        if (!w || !h) { reject(new Error('dimensions inconnues')); return; }
        if (w > max || h > max) { const r = Math.min(max / w, max / h); w = Math.round(w * r); h = Math.round(h * r); }
        const c = document.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        c.toBlob(function (b) { b ? resolve(b) : reject(new Error('canvas')); }, 'image/jpeg', 0.85);
      });
    });
  }

  // Les iPhone produisent des HEIC que ni le navigateur de bureau ni Shopify n acceptent.
  // On charge un decodeur uniquement dans ce cas : les autres visiteurs ne telechargent rien.
  function loadHeicDecoder() {
    if (window.heic2any) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      const sc = document.createElement('script');
      sc.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      sc.onload = function () { window.heic2any ? resolve() : reject(new Error('decodeur absent')); };
      sc.onerror = function () { reject(new Error('decodeur indisponible')); };
      document.head.appendChild(sc);
    });
  }
  function heicToJpeg(file) {
    return loadHeicDecoder()
      .then(function () { return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 }); })
      .then(function (out) { return Array.isArray(out) ? out[0] : out; });
  }

  function photoPost(fields) {
    return fetch(PHOTO_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(fields)
    }).then(function (r) { return r.json(); });
  }


  // Photo choisie pendant le questionnaire : le fichier est deja chez Shopify, il ne
  // reste qu a le rattacher au client. Ce client est cree par le Capture APRES la
  // generation des paroles, une cinquantaine de secondes apres l envoi du formulaire.
  // On ne se fie donc a aucune branche de l interrogation : on reessaie tout seul.
  let photoQuizFaite = false;
  function photoDejaLa(data) {
    if (data && data.photo_url) { photoQuizFaite = true; oublierCible(); }
  }
  function oublierCible() {
    try { sessionStorage.removeItem('ym_photo_attente'); } catch (e) {}
  }
  // Apercu laisse par le questionnaire : meme jeton, sinon on l ignore.
  function montrerApercu() {
    let brut = null;
    try { brut = sessionStorage.getItem('ym_photo_apercu'); } catch (e) { return false; }
    if (!brut) return false;
    let a = null;
    try { a = JSON.parse(brut); } catch (e) { a = null; }
    if (!a || a.token !== token || !a.src) return false;
    restorePhoto(a.src);
    return true;
  }
  function oublierApercu() {
    try { sessionStorage.removeItem('ym_photo_apercu'); } catch (e) {}
  }
  function redemanderPhoto() {
    root.querySelectorAll('[data-ym="photo-block"]').forEach(function (bloc) {
      const done = bloc.querySelector('[data-ym="photo-done"]');
      const label = bloc.querySelector('.ym-photo__btn');
      const load = bloc.querySelector('[data-ym="photo-loading"]');
      bloc.hidden = false;
      bloc.classList.remove('ym-photo--seule');
      if (done) done.hidden = true;
      if (load) load.hidden = true;
      if (label) label.hidden = false;
    });
    showCover('');
  }

  function cibleDuQuiz() {
    // L adresse fait foi : le jeton et la reference du fichier y sont arrives ensemble.
    const parAdresse = urlParams.get('ph');
    if (parAdresse) return parAdresse;
    let brut = null;
    try { brut = sessionStorage.getItem('ym_photo_attente'); } catch (e) { return ''; }
    if (!brut) return '';
    let att = null;
    try { att = JSON.parse(brut); } catch (e) { att = null; }
    if (!att || att.token !== token || !att.resource_url) { oublierCible(); return ''; }
    return att.resource_url;
  }
  // Montre « envoi en cours » sur les deux blocs, sans toucher a l etat « photo ajoutee ».
  function photoEnCours(oui) {
    root.querySelectorAll('[data-ym="photo-block"]').forEach(function (bloc) {
      const label = bloc.querySelector('.ym-photo__btn');
      const load = bloc.querySelector('[data-ym="photo-loading"]');
      const err = bloc.querySelector('[data-ym="photo-error"]');
      if (label) label.hidden = oui;
      if (load) load.hidden = !oui;
      if (oui && err) err.hidden = true;
    });
  }
  // Vrai des que l API a repondu pour ce jeton : le Capture a fini d ecrire le client.
  // Tant que c est faux, appeler le rattachement ne ferait que creer un fichier orphelin.
  let clientPret = false;
  const enAttenteDuClient = [];
  function clientEstPret() {
    if (clientPret) return;
    clientPret = true;
    while (enAttenteDuClient.length) enAttenteDuClient.shift()();
  }
  // Rend la main des que le client existe, ou abandonne au bout de 5 minutes.
  function quandClientPret(faire) {
    if (clientPret) { faire(); return; }
    enAttenteDuClient.push(faire);
    setTimeout(function () {
      const i = enAttenteDuClient.indexOf(faire);
      if (i > -1) { enAttenteDuClient.splice(i, 1); faire(false); }
    }, 300000);
  }

  function rattacherPhotoDuQuiz() {
    if (!PHOTO_API || !token) return;
    const cible = cibleDuQuiz();
    if (!cible) return;
    // Une photo est en route. Si on en a un apercu, on la montre tout de suite : le
    // visiteur voit sa photo a la seconde ou il arrive, sans attendre le serveur.
    if (!montrerApercu()) photoEnCours(true);
    // UN SEUL appel, et seulement quand le client existe : chaque appel cree un fichier.
    quandClientPret(function (ok) {
      if (photoQuizFaite) return;
      if (ok === false) { oublierCible(); oublierApercu(); redemanderPhoto(); return; }
      photoQuizFaite = true;
      photoPost({ action: 'attach', token: token, resource_url: cible })
        .then(function (res) {
          if (!(res && res.photo_url)) throw new Error('rattachement sans reponse');
          oublierCible(); oublierApercu();
          if (previewData) previewData.photo_url = res.photo_url;
          restorePhoto(res.photo_url);
        })
        .catch(function (e) {
          // Pas de seconde tentative : elle creerait un second fichier. On redemande.
          oublierCible(); oublierApercu();
          redemanderPhoto();
          console.warn('[ym-preview] photo du questionnaire non rattachee', e);
        });
    });
  }

  // On attend que le client existe, puis UN SEUL appel : chaque appel cree un fichier
  // chez Shopify, meme quand il echoue. Reessayer, c est semer des orphelins.
  function attacherAvecReprise(resourceUrl) {
    return new Promise(function (resoudre, rejeter) {
      quandClientPret(function (ok) {
        if (ok === false) { rejeter(new Error('client jamais apparu')); return; }
        photoPost({ action: 'attach', token: token, resource_url: resourceUrl })
          .then(function (res) {
            if (res && res.photo_url) { resoudre(res); return; }
            rejeter(new Error('rattachement sans reponse'));
          })
          .catch(rejeter);
      });
    });
  }

  function initPhoto() {
    root.querySelectorAll('[data-ym="photo-block"]').forEach(brancherPhoto);
    brancherChangementParLaPhoto();
  }
  function brancherPhoto(block) {
    const input = block.querySelector('[data-ym="photo-input"]');
    if (!block || !input || !PHOTO_API || !token) { if (block) block.hidden = true; return; }
    const done = block.querySelector('[data-ym="photo-done"]');
    const thumb = block.querySelector('[data-ym="photo-thumb"]');
    const errEl = block.querySelector('[data-ym="photo-error"]');
    const label = block.querySelector('.ym-photo__btn');
    const loadEl = block.querySelector('[data-ym="photo-loading"]');
    const change = block.querySelector('[data-ym="photo-change"]');
    let busy = false, lisible = true;

    function fail(msg) {
      // On rouvre le bloc : sans ca, un changement rate depuis la couverture laisserait
      // le visiteur devant une photo qui ne repond plus et aucun message.
      block.hidden = false;
      block.classList.remove('ym-photo--seule');
      if (loadEl) loadEl.hidden = true;
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      if (label) label.hidden = false;
      busy = false;
    }

    input.addEventListener('change', async function () {
      const file = input.files && input.files[0];
      if (!file || busy) return;
      busy = true;
      if (errEl) errEl.hidden = true;
      if (label) label.hidden = true;
      if (loadEl) loadEl.hidden = false;
      try {
        // On redimensionne quand le navigateur sait lire le fichier ; sinon on envoie
        // l original tel quel et Shopify se debrouille (cas des HEIC sur poste fixe).
        let blob, mime = 'image/jpeg', ext = 'jpg';
        lisible = true;
        try {
          blob = await shrink(file);
        } catch (e) {
          try {
            // Photo iPhone non convertie : on la decode puis on la traite comme une JPEG normale.
            blob = await shrink(await heicToJpeg(file));
          } catch (e2) {
            // Dernier recours : on envoie l original tel quel, Shopify tranchera.
            lisible = false;
            blob = file;
            mime = file.type || 'application/octet-stream';
            ext = (file.name.split('.').pop() || 'jpg').toLowerCase().slice(0, 5);
          }
        }
        const maVersion = ++photoVersion;
        let apercu = '';
        try { apercu = URL.createObjectURL(lisible ? blob : file); } catch (e) {}
        if (apercu && lisible) restorePhoto(apercu);   // 14/10 : plus d'attente visible, la photo est là tout de suite
        const target = await photoPost({ action: 'target', token: token, mime: mime, ext: ext });
        if (!target || !target.upload_url) throw new Error('cible indisponible');
        const put = await fetch(target.upload_url, { method: 'PUT', headers: { 'Content-Type': mime }, body: blob });
        if (!put.ok) throw new Error('envoi refuse ' + put.status);
        // Le client peut ne pas encore exister : le Capture l ecrit une cinquantaine de
        // secondes apres l envoi du formulaire. On rejoue le rattachement, le fichier
        // lui est deja chez Shopify, il n y a rien a renvoyer.
        const res = await attacherAvecReprise(target.resource_url);
        if (!res || !res.photo_url) throw new Error('rattachement impossible');
        busy = false;
        if (maVersion !== photoVersion) { if (!previewData || !previewData.photo_url) photoPost({ action: 'remove', token: token }).catch(function () {}); return; }   // retirée ou changée pendant l'envoi
        if (previewData) previewData.photo_url = res.photo_url;
        try { const k = 'ym_pv_' + token, c = JSON.parse(localStorage.getItem(k) || 'null'); if (c && c.d) { c.d.photo_url = res.photo_url; localStorage.setItem(k, JSON.stringify(c)); } } catch (e) {}
        if (!lisible) restorePhoto(res.photo_url);
      } catch (e) {
        console.warn('[ym-preview] photo', e);
        fail(lisible ? (t.photoError || 'Envoi impossible.') : (t.photoFormat || t.photoError));
      }
    });

    const rmBtn = block.querySelector('[data-ym="photo-remove"]');
    if (rmBtn) rmBtn.addEventListener('click', function () { retirerPhoto(); });
    if (change) change.addEventListener('click', function () {
      if (done) done.hidden = true;
      if (loadEl) loadEl.hidden = true;
      if (label) label.hidden = false;
      input.value = '';
    });
  }
  // ============================================================
  //  Audio player (custom controls)
  // ============================================================
  const audio = root.querySelector('[data-ym="audio"]');
  const playBtn = root.querySelector('[data-ym="play-btn"]');
  const playIcon = root.querySelector('[data-ym="play-icon"]');
  const pauseIcon = root.querySelector('[data-ym="pause-icon"]');
  const progressBar = root.querySelector('[data-ym="progress-bar"]');
  const playLabelEl = root.querySelector('[data-ym="play-label"]');

  // Cap playback to 90 seconds (we deliver a preview, not the full track) — decision du 22/09/2026
  const PREVIEW_MAX_SECONDS = 90;

  function setPlaying(isPlaying) {
    if (!playIcon || !pauseIcon) return;
    // Use setAttribute for reliable cross-browser hide on SVG elements
    if (isPlaying) {
      playIcon.setAttribute('hidden', '');
      pauseIcon.removeAttribute('hidden');
    } else {
      pauseIcon.setAttribute('hidden', '');
      playIcon.removeAttribute('hidden');
    }
    if (playLabelEl) playLabelEl.textContent = isPlaying ? t.pauseLabel : t.playLabel;
  }

  // setInterval-driven progress bar instead of `timeupdate` event because the latter
  // was firing spuriously (even paused) and snapping the width back to 0%. The interval
  // only ticks while audio is actually playing.
  let progressTicker = null;
  // Fire-once guards for the funnel telemetry events (PreviewLanded / PreviewPlayed).
  function startProgressTicker() {
    stopProgressTicker();
    progressTicker = setInterval(() => {
      if (!audio || audio.paused || audio.ended || !progressBar) return;
      ymtTick();
      if (audio.currentTime >= PREVIEW_MAX_SECONDS) {
        ymt('preview_end', { listen_step: 90 }); ymtSteps = {}; ymfbShow();
        audio.pause();
        audio.currentTime = 0;
        setTimeout(function () { if (audio.paused && audio.currentTime > 1) audio.currentTime = 0; }, 250);
        progressBar.style.setProperty('width', '0%', 'important');
        stopProgressTicker();
        return;
      }
      const pct = (audio.currentTime / PREVIEW_MAX_SECONDS) * 100;
      progressBar.style.setProperty('width', pct + '%', 'important');
    }, 100);
  }
  // 15/10/2026 (Thibaut) : le lead a deja donne son email ; on le remet dans le paiement pour que rien ne begaie.
  // Source : le parametre _se des liens Brevo (email en base64), garde par jeton dans localStorage.
  function ymEmailConnu() {
    try {
      var tk = new URLSearchParams(window.location.search).get('t') || '';
      var k = 'ym_em_' + tk;
      var se = new URLSearchParams(window.location.search).get('_se');
      if (se) {
        var e = atob(se.replace(/-/g, '+').replace(/_/g, '/')).trim();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) { try { localStorage.setItem(k, e); } catch (x) {} return e; }
      }
      // 16/10/2026 (v2) : sans _se (retour par SMS, mail d'Emma, URL tapee), l'email vient de la Data API (reponse gardee dans window.__ymPreview).
      var d = window.__ymPreview, em = d && d.email ? String(d.email).trim() : '';
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { try { localStorage.setItem(k, em); } catch (x) {} return em; }
      return localStorage.getItem(k) || '';
    } catch (e) { return ''; }
  }
  // 16/10/2026 : Shopify ignore checkout[email] sur /checkout (verifie en navigateur vierge, mobile et bureau) ; seul le permalien
  // panier le respecte, avec les proprietes de ligne du 1er article en base64 (doc Shopify « Create cart permalinks »).
  // Le permalien repart d un panier neuf : impossible quand une plaque/magnet avec photo est deja dans le panier -> /checkout comme avant.
  function ymCheckoutUrl(items, avecPhoto) {
    var e = ymEmailConnu();
    // 23/10/2026 : les replis gardent aussi la langue de la page (avant : /checkout = paiement en francais pour ja, it, nl, es, en, de)
    var racine = '/';
    try { racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || ((location.pathname.match(/^\/(en|de|es|ja|it|nl|sv|da|nb|pt|fi)\//) || [])[0]) || '/'; } catch (x) {}
    if (!e || avecPhoto || !items || !items.length) return racine + 'checkout';
    try {
      var chemin = items.map(function (i) { return i.id + ':' + (i.quantity || 1); }).join(',');
      var props = items[0].properties || {}, q = 'checkout%5Bemail%5D=' + encodeURIComponent(e);
      // 16/10/2026 : le telephone du quiz (Data API) pre-remplit aussi le champ obligatoire du paiement (facturation ou livraison).
      var d = window.__ymPreview, tel = d && d.phone ? String(d.phone).trim() : '';
      if (/^\+?[0-9 ()\-]{6,20}$/.test(tel)) q += '&checkout%5Bbilling_address%5D%5Bphone%5D=' + encodeURIComponent(tel) + '&checkout%5Bshipping_address%5D%5Bphone%5D=' + encodeURIComponent(tel);
      if (Object.keys(props).length) q = 'properties=' + encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(props))))) + '&' + q;
      // 17/10/2026 : a la racine, le panier se creait en francais (customerLocale fr-US) pour les anglophones : on garde la langue de la page (/en/, /de/).
      return racine + 'cart/' + chemin + '?' + q;
    } catch (x) { return racine + 'checkout'; }
  }
  // 28/09/2026 : tag « extrait lance » a la premiere lecture (scenario Make dedie 7652483), une fois par jeton et par navigateur.
  var PLAY_HOOK = 'https://api.yourmelody.org/v1/play';
  function signalerLecture() {
    var t = '';
    try { t = new URLSearchParams(window.location.search).get('t') || ''; } catch (e) {}
    if (!t) return;
    try { if (localStorage.getItem('ym_play_' + t)) return; localStorage.setItem('ym_play_' + t, '1'); } catch (e) {}
    try { fetch(PLAY_HOOK + '?t=' + encodeURIComponent(t), { method: 'GET', mode: 'no-cors', keepalive: true }).catch(function () {}); } catch (e) {}
  }
  function stopProgressTicker() {
    if (progressTicker) { clearInterval(progressTicker); progressTicker = null; }
  }

  // 15/10/2026 (Thibaut, priorite 1 du chantier mails) : profondeur d'ecoute vers GA4 (G-MT6SHRGNDF).
  // preview_play (1re lecture), preview_listen a chaque palier de 15 s atteint (listen_step 15..90), preview_pause,
  // preview_end (borne des 90 s), preview_exit a la fermeture (listen_max = position maximale atteinte, en secondes).
  var YMT_TOK = '', YMT_V = 'v4', YMT_LOC = ((document.documentElement.lang || '').slice(0, 2) || 'en');
  try { YMT_TOK = new URLSearchParams(window.location.search).get('t') || ''; } catch (e) {}
  if (/q7$/.test(YMT_TOK)) YMT_V = 'v6'; else if (/q6$/.test(YMT_TOK)) YMT_V = 'v5b'; else if (/q5$/.test(YMT_TOK)) YMT_V = 'v5';
  // 25/10/2026 : source d arrivee sur la page (mail, sms, quiz, pub...) pour relier l ecoute a l achat
  var YMT_SRC = 'direct';
  try {
    var _q = new URLSearchParams(window.location.search), _r = (document.referrer || '');
    if (_q.get('utm_source')) YMT_SRC = (_q.get('utm_source') + '/' + (_q.get('utm_medium') || '')).slice(0, 40);
    else if (_q.get('s')) YMT_SRC = 'quiz';
    else if (_q.get('gclid')) YMT_SRC = 'google';
    else if (_q.get('fbclid')) YMT_SRC = 'meta';
    else if (/brevo|sendibt|r\.yourmelody|sib\./i.test(_r)) YMT_SRC = 'mail';
    else if (_r) { var _h = /^https?:\/\/([^\/]+)/.exec(_r); YMT_SRC = (_h ? _h[1] : 'referrer').replace(/^www\./, '').slice(0, 40); }
  } catch (e) {}
  var ymtMax = 0, ymtPlayed = false, ymtPlays = 0, ymtSteps = {}, ymtExitSent = false;
  function ymt(ev, p) {
    try {
      if (typeof window.gtag !== 'function') return;
      p = p || {};
      p.send_to = 'G-MT6SHRGNDF'; p.quiz_v = YMT_V; p.quiz_loc = YMT_LOC; p.quiz_src = YMT_SRC; p.transport_type = 'beacon';
      p.listen_t = Math.round((audio && audio.currentTime) || 0); p.listen_max = Math.round(ymtMax); p.listen_play = ymtPlays;
      window.gtag('event', ev, p);
    } catch (e) {}
  }
  function ymtTick() {
    try {
      if (!audio) return;
      var c = audio.currentTime || 0; if (c > ymtMax) ymtMax = c;
      var step = Math.floor(c / 15) * 15;
      if (step >= 15 && step <= 90 && !ymtSteps[step]) { ymtSteps[step] = 1; ymt('preview_listen', { listen_step: step }); }
    } catch (e) {}
  }

  // 17/10/2026 (Thibaut, principe Foreversongs ameliore) : a la fin de l'extrait, la case du lecteur devient une carte d'avis (meme case).
  // 4-5 etoiles -> merci, la chanson complete attend juste en dessous ; 1-3 -> « que changeriez-vous ? » (choix + texte libre) ->
  // reponse signee par la songwriter : modifications gratuites apres l'achat. Aucun defilement automatique (le client lit et trouve son chemin).
  // « Reecouter » rend le lecteur. A/B par jeton (somme des codes de caracteres : paire = carte, impaire = rien) ; ?fb=1 / ?fb=0 pour les tests.
  // GA4 : preview_fbx_fb / preview_fbx_ctrl (exposition a la fin de l'ecoute), preview_fb_r1..r5, preview_fb_<raison>, preview_fb_send.
  // L'avis part aussi dans la ligne panier (_ym_avis) : l'equipe et l'agent le voient sur la commande.
  // 28/10 (go de Thibaut) : A/B « case de texte pour 1, 2 et 3 etoiles » (ymfbCaseBras). Bras a : comme avant (case de texte seulement pour « Autre chose »).
  // Bras b : la case s'ouvre pour chaque raison, avec un exemple adapte (YMFB_TXT.<lg>.ex), facultative sauf pour « Autre chose » (3 caracteres, comme avant).
  // Bras = FNV-1a 32 bits de « ymfb-case:<jeton> », bit de poids fort 1 -> b ; meme fonction que brasCaseAvis du moteur (gabarits_b1_avis.js).
  // ?ymfb_bras=a ou ?ymfb_bras=b force le bras pour les tests. Le bras part au moteur (parametre bras) et dans les evenements GA4 de la carte (fb_case).
  var YMFB_TXT = {
    en: { kick: 'Your preview', q: "How do you like {n}'s song so far?", q0: 'How do you like your song so far?', lo: 'Needs work', hi: 'Love it!', again: 'Listen again',
          ok1: 'Wonderful 🎉', ok2: 'So glad you love it. The full song for {n} is waiting for you just below.', ok20: 'So glad you love it. The full song is waiting for you just below.',
          bad: 'What would you change?', r: { voice: "🎤 The voice didn't fit", lyrics: "📝 The lyrics didn't fit", genre: '🎵 Wrong genre or vibe', personal: "💭 It didn't feel personal enough", other: '✏️ Something else' },
          ph: "Tell me what you'd like changed…", send: 'Send my feedback',
          ex: { voice: 'For example: a male voice, softer, deeper…', lyrics: 'For example: the line to change, a name sung wrong, a memory to add…', genre: 'For example: more rock, slower, more upbeat…', personal: 'For example: a nickname, a memory, a date that matters…' },
          fix1: 'Got it, thank you!', fix2: "Your purchase includes <b>free changes</b>: unlock the full song below and I'll contact you right after to adjust it myself so it sounds exactly the way you want." },
    fr: { kick: 'Votre extrait', q: 'Que pensez-vous de la chanson de {n} ?', q0: 'Que pensez-vous de votre chanson ?', lo: 'À retravailler', hi: "J'adore !", again: 'Réécouter',
          ok1: 'Merveilleux 🎉', ok2: 'Ravis qu’elle vous plaise. La chanson complète de {n} vous attend juste en dessous.', ok20: 'Ravis qu’elle vous plaise. La chanson complète vous attend juste en dessous.',
          bad: 'Que changeriez-vous ?', r: { voice: '🎤 La voix ne convenait pas', lyrics: '📝 Les paroles ne convenaient pas', genre: '🎵 Pas le bon style ou la bonne ambiance', personal: '💭 Pas assez personnel', other: '✏️ Autre chose' },
          ph: 'Dites-moi ce que vous aimeriez changer…', send: 'Envoyer mon avis',
          ex: { voice: 'Par exemple : une voix d\'homme, plus douce, plus grave…', lyrics: 'Par exemple : la ligne à changer, un prénom mal dit, un souvenir à ajouter…', genre: 'Par exemple : plus rock, plus lent, plus festif…', personal: 'Par exemple : un surnom, un souvenir, une date qui compte…' },
          fix1: 'C’est noté, merci !', fix2: 'Votre achat inclut les <b>modifications gratuites</b> : débloquez la chanson complète ci-dessous et je vous contacte juste après pour l’ajuster moi-même, afin qu’elle sonne exactement comme vous le souhaitez.' },
    de: { kick: 'Ihre Hörprobe', q: 'Wie gefällt Ihnen das Lied für {n} bisher?', q0: 'Wie gefällt Ihnen Ihr Lied bisher?', lo: 'Ausbaufähig', hi: 'Wunderschön!', again: 'Nochmal anhören',
          ok1: 'Wunderbar 🎉', ok2: 'Schön, dass es Ihnen gefällt. Das ganze Lied für {n} wartet direkt hier unten auf Sie.', ok20: 'Schön, dass es Ihnen gefällt. Das ganze Lied wartet direkt hier unten auf Sie.',
          bad: 'Was würden Sie ändern?', r: { voice: '🎤 Die Stimme passte nicht', lyrics: '📝 Der Text passte nicht', genre: '🎵 Falscher Stil oder falsche Stimmung', personal: '💭 Nicht persönlich genug', other: '✏️ Etwas anderes' },
          ph: 'Sagen Sie mir, was Sie ändern möchten…', send: 'Feedback senden',
          ex: { voice: 'Zum Beispiel: eine Männerstimme, sanfter, tiefer…', lyrics: 'Zum Beispiel: die Zeile, die sich ändern soll, ein falsch gesungener Name, eine Erinnerung, die noch fehlt…', genre: 'Zum Beispiel: rockiger, langsamer, ausgelassener…', personal: 'Zum Beispiel: ein Spitzname, eine Erinnerung, ein wichtiges Datum…' },
          fix1: 'Notiert, danke!', fix2: 'Ihr Kauf enthält <b>kostenlose Änderungen</b>: Schalten Sie das ganze Lied unten frei, und ich melde mich direkt danach bei Ihnen, um es selbst anzupassen, damit es genau so klingt, wie Sie es möchten.' },
    ja: { kick: 'あなたの試聴版', q: '{n}への歌、ここまでいかがですか？', q0: 'あなたの歌、ここまでいかがですか？', lo: 'いまひとつ', hi: '大好き！', again: 'もう一度聴く',
          ok1: 'ありがとうございます 🎉', ok2: '気に入っていただけてうれしいです。{n}への歌のフルバージョンは、このすぐ下でお待ちしています。', ok20: '気に入っていただけてうれしいです。フルバージョンは、このすぐ下でお待ちしています。',
          bad: 'どこを変えたいですか？', r: { voice: '🎤 歌声が合わなかった', lyrics: '📝 歌詞が合わなかった', genre: '🎵 曲調や雰囲気が違った', personal: '💭 その人らしさが足りなかった', other: '✏️ その他' },
          ph: '変えたいところを教えてください…', send: '感想を送る',
          ex: { voice: '例：男性の声、もっとやさしく、もっと低く…', lyrics: '例：変えたい一行、名前の読み方のまちがい、加えたい思い出…', genre: '例：もっとロック調に、もっとゆったり、もっとにぎやかに…', personal: '例：あだ名、思い出、大切な記念日…' },
          fix1: '承知しました。ありがとうございます！', fix2: 'ご購入には<b>無料の修正</b>が含まれています。下からフルバージョンをお申し込みいただければ、そのあとすぐに私からご連絡し、ご希望どおりの仕上がりになるよう私自身で調整します。' },
    it: { kick: 'La tua anteprima', q: 'Cosa ne pensi finora della canzone per {n}?', q0: 'Cosa ne pensi finora della tua canzone?', lo: 'Da migliorare', hi: 'La adoro!', again: 'Riascolta',
          ok1: 'Meraviglioso 🎉', ok2: 'Che bello che ti piaccia. La canzone completa per {n} ti aspetta qui sotto.', ok20: 'Che bello che ti piaccia. La canzone completa ti aspetta qui sotto.',
          bad: 'Cosa cambieresti?', r: { voice: '🎤 La voce non era quella giusta', lyrics: '📝 Il testo non era quello giusto', genre: '🎵 Genere o atmosfera sbagliati', personal: '💭 Non abbastanza personale', other: '✏️ Altro' },
          ph: 'Dimmi cosa vorresti cambiare…', send: 'Invia il mio parere',
          ex: { voice: 'Per esempio: una voce maschile, più dolce, più profonda…', lyrics: 'Per esempio: il verso da cambiare, un nome pronunciato male, un ricordo da aggiungere…', genre: 'Per esempio: più rock, più lenta, più festosa…', personal: 'Per esempio: un soprannome, un ricordo, una data importante…' },
          fix1: 'Ricevuto, grazie!', fix2: 'Il tuo acquisto include le <b>modifiche gratuite</b>: sblocca la canzone completa qui sotto e ti contatto subito dopo per sistemarla io stessa, così suonerà esattamente come la desideri.' },
    nl: { kick: 'Je fragment', q: 'Wat vind je tot nu toe van het lied voor {n}?', q0: 'Wat vind je tot nu toe van je lied?', lo: 'Kan beter', hi: 'Prachtig!', again: 'Nog eens luisteren',
          ok1: 'Geweldig 🎉', ok2: 'Fijn dat je het mooi vindt. Het volledige lied voor {n} wacht hieronder op je.', ok20: 'Fijn dat je het mooi vindt. Het volledige lied wacht hieronder op je.',
          bad: 'Wat zou je veranderen?', r: { voice: '🎤 De stem paste niet', lyrics: '📝 De tekst paste niet', genre: '🎵 Verkeerd genre of verkeerde sfeer', personal: '💭 Niet persoonlijk genoeg', other: '✏️ Iets anders' },
          ph: 'Vertel me wat je anders zou willen…', send: 'Verstuur mijn feedback',
          ex: { voice: 'Bijvoorbeeld: een mannenstem, zachter, lager…', lyrics: 'Bijvoorbeeld: de regel die anders moet, een verkeerd gezongen naam, een herinnering die erbij moet…', genre: 'Bijvoorbeeld: meer rock, langzamer, feestelijker…', personal: 'Bijvoorbeeld: een bijnaam, een herinnering, een datum die veel betekent…' },
          fix1: 'Genoteerd, dank je!', fix2: 'Je aankoop is inclusief <b>gratis aanpassingen</b>: ontgrendel hieronder het volledige lied en ik neem direct daarna contact met je op om het zelf bij te werken, zodat het precies klinkt zoals jij wilt.' },
    sv: { kick: 'Ditt smakprov', q: 'Vad tycker du om låten till {n} hittills?', q0: 'Vad tycker du om din låt hittills?', lo: 'Kan bli bättre', hi: 'Underbart!', again: 'Lyssna igen',
          ok1: 'Härligt 🎉', ok2: 'Vad roligt att du gillar den. Hela låten till {n} väntar på dig här nedanför.', ok20: 'Vad roligt att du gillar den. Hela låten väntar på dig här nedanför.',
          bad: 'Vad skulle du vilja ändra?', r: { voice: '🎤 Rösten passade inte', lyrics: '📝 Texten passade inte', genre: '🎵 Fel genre eller stämning', personal: '💭 Inte personlig nog', other: '✏️ Något annat' },
          ph: 'Berätta vad du vill ändra…', send: 'Skicka min feedback',
          ex: { voice: 'Till exempel: en mansröst, mjukare, mörkare…', lyrics: 'Till exempel: raden som ska ändras, ett namn som uttalas fel, ett minne att lägga till…', genre: 'Till exempel: rockigare, långsammare, mer festlig…', personal: 'Till exempel: ett smeknamn, ett minne, ett datum som betyder något…' },
          fix1: 'Uppfattat, tack!', fix2: 'I ditt köp ingår <b>gratis ändringar</b>: lås upp hela låten här nedanför så hör jag av mig direkt efteråt och justerar den själv, så att den låter precis som du vill.' },
    da: { kick: 'Din smagsprøve', q: 'Hvad synes du indtil videre om sangen til {n}?', q0: 'Hvad synes du indtil videre om din sang?', lo: 'Kan blive bedre', hi: 'Elsker den!', again: 'Lyt igen',
          ok1: 'Skønt 🎉', ok2: 'Hvor dejligt, at du kan lide den. Hele sangen til {n} venter på dig lige herunder.', ok20: 'Hvor dejligt, at du kan lide den. Hele sangen venter på dig lige herunder.',
          bad: 'Hvad ville du ændre?', r: { voice: '🎤 Stemmen passede ikke', lyrics: '📝 Teksten passede ikke', genre: '🎵 Forkert genre eller stemning', personal: '💭 Ikke personlig nok', other: '✏️ Noget andet' },
          ph: 'Fortæl mig, hvad du gerne vil have ændret…', send: 'Send min feedback',
          ex: { voice: 'For eksempel: en mandestemme, blødere, dybere…', lyrics: 'For eksempel: linjen, der skal ændres, et navn, der udtales forkert, et minde, der skal med…', genre: 'For eksempel: mere rock, langsommere, mere festlig…', personal: 'For eksempel: et kælenavn, et minde, en dato, der betyder noget…' },
          fix1: 'Noteret, tak!', fix2: 'Dit køb inkluderer <b>gratis ændringer</b>: lås op for hele sangen herunder, så kontakter jeg dig lige bagefter og justerer den selv, så den lyder præcis, som du vil have den.' },
    nb: { kick: 'Smakebiten din', q: 'Hva synes du om sangen til {n} så langt?', q0: 'Hva synes du om sangen din så langt?', lo: 'Kan bli bedre', hi: 'Nydelig!', again: 'Hør igjen',
          ok1: 'Herlig 🎉', ok2: 'Så glad for at du liker den. Hele sangen til {n} venter på deg rett nedenfor.', ok20: 'Så glad for at du liker den. Hele sangen venter på deg rett nedenfor.',
          bad: 'Hva ville du endret?', r: { voice: '🎤 Stemmen passet ikke', lyrics: '📝 Teksten passet ikke', genre: '🎵 Feil sjanger eller stemning', personal: '💭 Ikke personlig nok', other: '✏️ Noe annet' },
          ph: 'Fortell meg hva du vil ha endret…', send: 'Send tilbakemeldingen min',
          ex: { voice: 'For eksempel: en mannsstemme, mykere, dypere…', lyrics: 'For eksempel: linjen som skal endres, et navn som uttales feil, et minne som bør være med…', genre: 'For eksempel: mer rock, saktere, mer festlig…', personal: 'For eksempel: et kallenavn, et minne, en dato som betyr noe…' },
          fix1: 'Notert, tusen takk!', fix2: 'Kjøpet ditt inkluderer <b>gratis endringer</b>: lås opp hele sangen nedenfor, så tar jeg kontakt med deg rett etterpå og justerer den selv, slik at den låter akkurat som du vil.' },
    pt: { kick: 'A sua amostra', q: 'O que acha, até agora, da canção para {n}?', q0: 'O que acha, até agora, da sua canção?', lo: 'Pode melhorar', hi: 'Adoro!', again: 'Ouvir outra vez',
          ok1: 'Que bom 🎉', ok2: 'Ainda bem que gosta. A canção completa para {n} está à sua espera logo abaixo.', ok20: 'Ainda bem que gosta. A canção completa está à sua espera logo abaixo.',
          bad: 'O que mudaria?', r: { voice: '🎤 A voz não encaixou', lyrics: '📝 A letra não encaixou', genre: '🎵 Género ou ambiente errado', personal: '💭 Não ficou pessoal o suficiente', other: '✏️ Outra coisa' },
          ph: 'Diga-me o que gostaria de mudar…', send: 'Enviar a minha opinião',
          ex: { voice: 'Por exemplo: uma voz masculina, mais suave, mais grave…', lyrics: 'Por exemplo: o verso a mudar, um nome mal pronunciado, uma memória a acrescentar…', genre: 'Por exemplo: mais rock, mais lenta, mais festiva…', personal: 'Por exemplo: uma alcunha, uma memória, uma data importante…' },
          fix1: 'Anotado, obrigada!', fix2: 'A sua compra inclui <b>alterações gratuitas</b>: desbloqueie a canção completa abaixo e eu entro em contacto consigo logo a seguir para a ajustar pessoalmente, para que soe exatamente como deseja.' },
    fi: { kick: 'Näytteesi', q: '{n} saa tämän laulun. Mitä pidät siitä tähän mennessä?', q0: 'Mitä pidät laulustasi tähän mennessä?', lo: 'Kaipaa hiomista', hi: 'Ihana!', again: 'Kuuntele uudelleen',
          ok1: 'Upeaa 🎉', ok2: 'Ihanaa, että pidät siitä. Koko laulu odottaa sinua heti alla, ja pian {n} saa kuulla sen.', ok20: 'Ihanaa, että pidät siitä. Koko laulu odottaa sinua heti alla.',
          bad: 'Mitä muuttaisit?', r: { voice: '🎤 Ääni ei sopinut', lyrics: '📝 Sanat eivät sopineet', genre: '🎵 Väärä tyylilaji tai tunnelma', personal: '💭 Ei tuntunut tarpeeksi henkilökohtaiselta', other: '✏️ Jokin muu' },
          ph: 'Kerro, mitä haluaisit muuttaa…', send: 'Lähetä palautteeni',
          ex: { voice: 'Esimerkiksi: miesääni, pehmeämpi, matalampi…', lyrics: 'Esimerkiksi: muutettava rivi, väärin laulettu nimi, lisättävä muisto…', genre: 'Esimerkiksi: rokkaavampi, hitaampi, juhlavampi…', personal: 'Esimerkiksi: lempinimi, muisto, tärkeä päivämäärä…' },
          fix1: 'Selvä, kiitos!', fix2: 'Ostokseesi sisältyvät <b>maksuttomat muutokset</b>: avaa koko laulu alta, niin otan sinuun yhteyttä heti sen jälkeen ja muokkaan sen itse juuri sellaiseksi kuin haluat.' },
    es: { kick: 'Tu adelanto', q: '¿Qué te parece la canción de {n} hasta ahora?', q0: '¿Qué te parece tu canción hasta ahora?', lo: 'Mejorable', hi: '¡Me encanta!', again: 'Escuchar de nuevo',
          ok1: '¡Maravilloso 🎉!', ok2: 'Nos alegra que te guste. La canción completa de {n} te espera justo aquí abajo.', ok20: 'Nos alegra que te guste. La canción completa te espera justo aquí abajo.',
          bad: '¿Qué cambiarías?', r: { voice: '🎤 La voz no encajaba', lyrics: '📝 La letra no encajaba', genre: '🎵 El estilo o el ambiente no era el adecuado', personal: '💭 No se sentía lo bastante personal', other: '✏️ Otra cosa' },
          ph: 'Cuéntame qué te gustaría cambiar…', send: 'Enviar mi opinión',
          ex: { voice: 'Por ejemplo: una voz de hombre, más suave, más grave…', lyrics: 'Por ejemplo: la frase que hay que cambiar, un nombre mal pronunciado, un recuerdo que añadir…', genre: 'Por ejemplo: más rock, más lento, más festivo…', personal: 'Por ejemplo: un apodo, un recuerdo, una fecha importante…' },
          fix1: '¡Anotado, gracias!', fix2: 'Tu compra incluye <b>cambios gratuitos</b>: desbloquea la canción completa aquí abajo y te escribo justo después para ajustarla yo misma, para que suene exactamente como quieres.' }
  };
  var ymfbArm = (function () {
    try {
      var f = new URLSearchParams(window.location.search).get('fb');
      if (f === '1') return 'fb'; if (f === '0') return 'ctrl';
      var s = 0, tk = YMT_TOK || ''; for (var i = 0; i < tk.length; i++) s += tk.charCodeAt(i);
      return 'fb';   // 24/10 (Thibaut) : carte pour tout le monde, fin de l'A/B (?fb=0 garde le témoin pour les tests)
    } catch (e) { return 'ctrl'; }
  })();
  var ymfbCaseBras = (function () {
    try {
      var f = new URLSearchParams(window.location.search).get('ymfb_bras');
      if (f === 'a' || f === 'b') return f;
      var h = 0x811c9dc5, s = 'ymfb-case:' + (YMT_TOK || '');
      for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
      return (h >>> 31) ? 'b' : 'a';
    } catch (e) { return 'a'; }
  })();
  var ymfbKey = 'ym_fb_' + (YMT_TOK || ''), ymfbExpo = false, ymfbEl = null;
  function ymfbLire() { try { return JSON.parse(localStorage.getItem(ymfbKey) || 'null'); } catch (e) { return null; } }
  function ymfbGarder(o) { try { localStorage.setItem(ymfbKey, JSON.stringify(o)); } catch (e) {} }
  // 24/10 (Thibaut) : chaque reponse de la carte part au moteur, acheteur ou non (note, case, texte, temps d'ecoute)
  function ymfbEnvoyer() {
    try {
      var a = ymfbLire(); if (!a || !a.n) return;
      var fd = new URLSearchParams(); fd.set('token', YMT_TOK || ''); fd.set('note', a.n); fd.set('raison', (a.r || []).join(',')); fd.set('texte', a.x || '');
      fd.set('listen_max', Math.round(ymtMax || 0)); fd.set('loc', String(listLocale || '').slice(0, 5)); fd.set('bras', ymfbCaseBras);
      fetch('https://ym-moteur.yourmelody.workers.dev/b/commandes/avis', { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd.toString() }).catch(function () {});
    } catch (e) {}
  }
  function ymfbAvisTexte() {
    var a = ymfbLire(); if (!a || !a.n) return '';
    return (a.n + '/5' + (a.r && a.r.length ? ' | ' + a.r.join(', ') : '') + (a.x ? ' | ' + a.x : '')).slice(0, 500);
  }
  function ymfbEsc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function ymfbStyle() {
    if (document.getElementById('ym-fb-style')) return;
    var st = document.createElement('style'); st.id = 'ym-fb-style';
    st.textContent = '.ym-fb{text-align:center;padding:2px 0 0}.ym-fb p{margin:0}'
      + '.ym-fb__kick{font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#6E6A86;margin:2px 0 8px!important}'
      + '.ym-fb__q{font-size:19px;font-weight:600;line-height:1.3;color:#1B2044;letter-spacing:-.01em;margin:0 6px 14px!important}'
      + '.ym-fb__stars{display:flex;justify-content:center;gap:6px;margin:0 0 4px}.ym-fb__star{background:none;border:0;padding:4px;cursor:pointer;line-height:0;-webkit-tap-highlight-color:transparent}'
      + '.ym-fb__star svg{width:40px;height:40px;fill:#fff;stroke:#D9CDF6;stroke-width:1.5;transition:fill .12s,stroke .12s,transform .12s}.ym-fb__star.on svg{fill:#6B45D1;stroke:#6B45D1;transform:scale(1.06)}'
      + '.ym-fb__ends{display:flex;justify-content:space-between;max-width:270px;margin:0 auto 4px;font-size:12.5px;color:#6E6A86}'
      + '.ym-fb__again{display:inline-flex;align-items:center;gap:6px;background:none;border:0;cursor:pointer;font:inherit;font-size:13.5px;color:#6E6A86;margin:10px auto 0;padding:6px 10px}'
      + '.ym-fb__big{font-size:22px;font-weight:600;color:#1B2044;margin:6px 0 6px!important}.ym-fb__msg{font-size:15px;line-height:1.55;color:#1B2044;margin:0 4px!important}'
      + '.ym-fb__opts{display:flex;flex-direction:column;gap:8px;margin:0 0 10px;text-align:left}'
      + '.ym-fb__opt{display:block;width:100%;text-align:left;font:inherit;font-size:15px;color:#1B2044;padding:12px 14px;border-radius:12px;border:1px solid #E7DCCB;background:#fff;cursor:pointer;-webkit-tap-highlight-color:transparent}'
      + '.ym-fb__opt.on{border-color:#6B45D1;background:#ECE6FB;color:#4a2fa3;font-weight:600}'
      + '.ym-fb__txt{width:100%;box-sizing:border-box;min-height:88px;font:inherit;font-size:16px;color:#1B2044;padding:12px 14px;border-radius:12px;border:1px solid #E7DCCB;background:#fff;margin:0 0 10px;resize:vertical}'
      + '.ym-fb__txt:focus{outline:none;border-color:#6B45D1}'
      + '.ym-fb__send{width:100%;font:inherit;font-weight:600;font-size:16px;padding:15px;border:0;border-radius:14px;background:#6B45D1;color:#fff;cursor:pointer;box-shadow:0 14px 30px -12px #6B45D1}.ym-fb__send:disabled{opacity:.4;box-shadow:none;cursor:default}'
      + '.ym-fb__sig{display:flex;align-items:center;justify-content:center;gap:10px;margin:12px 0 0}.ym-fb__sig img{width:36px;height:36px;border-radius:50%;object-fit:cover}.ym-fb__sig span{font-size:13.5px;font-style:italic;color:#6E6A86}';
    document.head.appendChild(st);
  }
  function ymfbNom() { try { return (window.__ymPreview && (window.__ymPreview.recipient_name || '')).trim(); } catch (e) { return ''; } }
  function ymfbSignature() {
    try {
      var note = root.querySelector('[data-ym="studio-note"]'); if (!note || note.hidden) return '';
      var img = root.querySelector('[data-ym="studio-note-avatar"]'), sig = root.querySelector('[data-ym="i18n-studio-note-sign"]');
      if (!sig || !sig.textContent.trim()) return '';
      return '<div class="ym-fb__sig">' + (img && img.src ? '<img src="' + ymfbEsc(img.src) + '" alt="">' : '') + '<span>' + ymfbEsc(sig.textContent.trim()) + '</span></div>';
    } catch (e) { return ''; }
  }
  function ymfbLecteur(montrer) {
    var player = root.querySelector('.ym-preview__player'); if (!player) return;
    [].forEach.call(player.children, function (c) { if (c === ymfbEl || c.tagName === 'AUDIO') return; if (montrer) { if (c.__ymfbCache) { c.style.display = c.__ymfbCache === '-' ? '' : c.__ymfbCache; c.__ymfbCache = null; } } else if (!c.__ymfbCache) { c.__ymfbCache = c.style.display || '-'; c.style.display = 'none'; } });
    if (ymfbEl) ymfbEl.hidden = !!montrer;
  }
  function ymfbRendre(etat) {
    var T = YMFB_TXT[String(listLocale || 'en').slice(0, 2)] || YMFB_TXT.en, n = ymfbEsc(ymfbNom());
    var again = '<button type="button" class="ym-fb__again" data-fb="again">↻ ' + T.again + '</button>';
    if (etat === 'ok') ymfbEl.innerHTML = '<p class="ym-fb__big">' + T.ok1 + '</p><p class="ym-fb__msg">' + (n ? T.ok2.replace('{n}', n) : T.ok20) + '</p>' + again;
    else if (etat === 'fix') ymfbEl.innerHTML = '<p class="ym-fb__big">' + T.fix1 + '</p><p class="ym-fb__msg">' + T.fix2 + '</p>' + ymfbSignature() + again;
    else if (etat === 'bad') {
      ymfbEl.innerHTML = '<p class="ym-fb__q">' + T.bad + '</p><div class="ym-fb__opts">' + Object.keys(T.r).map(function (k) {
        return '<button type="button" class="ym-fb__opt" data-fb-r="' + k + '">' + T.r[k] + '</button>'; }).join('')
        + '</div><textarea class="ym-fb__txt" data-fb="txt" placeholder="' + T.ph + '" hidden></textarea><button type="button" class="ym-fb__send" data-fb="send" disabled>' + T.send + '</button>' + again;
    } else {
      var etoiles = ''; for (var i = 1; i <= 5; i++) etoiles += '<button type="button" class="ym-fb__star" data-fb-n="' + i + '" aria-label="' + i + '/5"><svg viewBox="0 0 24 24"><path d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z" stroke-linejoin="round"/></svg></button>';
      ymfbEl.innerHTML = '<p class="ym-fb__kick">' + T.kick + '</p><p class="ym-fb__q">' + (n ? T.q.replace('{n}', n) : T.q0) + '</p><div class="ym-fb__stars">' + etoiles + '</div><div class="ym-fb__ends"><span>' + T.lo + '</span><span>' + T.hi + '</span></div>' + again;
    }
  }
  function ymfbMaj() {
    try {
      var on = ymfbEl.querySelectorAll('.ym-fb__opt.on'), tx = ymfbEl.querySelector('[data-fb="txt"]'), seulAutre = on.length === 1 && on[0].getAttribute('data-fb-r') === 'other';
      ymfbEl.querySelector('[data-fb="send"]').disabled = !on.length || (seulAutre && (!tx || tx.value.trim().length < 3));
    } catch (e) {}
  }
  function ymfbShow() {
    try {
      if (!ymfbExpo) { ymfbExpo = true; ymt('preview_fbx_' + ymfbArm, { fb_arm: ymfbArm, fb_case: ymfbCaseBras }); }
      if (ymfbArm !== 'fb') return;
      var player = root.querySelector('.ym-preview__player'); if (!player) return;
      ymfbStyle();
      if (!ymfbEl) {
        ymfbEl = document.createElement('div'); ymfbEl.className = 'ym-fb'; ymfbEl.setAttribute('data-ym', 'feedback');
        player.appendChild(ymfbEl);
        ymfbEl.addEventListener('mouseover', function (e) { var s = e.target.closest('.ym-fb__star'); if (!s) return; var k = +s.getAttribute('data-fb-n'); ymfbEl.querySelectorAll('.ym-fb__star').forEach(function (b) { b.classList.toggle('on', +b.getAttribute('data-fb-n') <= k); }); });
        ymfbEl.addEventListener('mouseout', function (e) { if (e.target.closest('.ym-fb__stars') && !(e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.ym-fb__stars'))) ymfbEl.querySelectorAll('.ym-fb__star').forEach(function (b) { b.classList.remove('on'); }); });
        ymfbEl.addEventListener('input', function (e) { if (e.target.getAttribute('data-fb') === 'txt') ymfbMaj(); });
        ymfbEl.addEventListener('click', function (e) {
          var s = e.target.closest('.ym-fb__star'), o = e.target.closest('.ym-fb__opt'), b = e.target.closest('[data-fb]');
          if (s) {
            var k = +s.getAttribute('data-fb-n'); ymfbEl.querySelectorAll('.ym-fb__star').forEach(function (x) { x.classList.toggle('on', +x.getAttribute('data-fb-n') <= k); });
            ymfbGarder({ n: k, r: [], x: '' }); ymfbEnvoyer(); ymt('preview_fb_r' + k, { rating: k, fb_case: ymfbCaseBras });
            setTimeout(function () { ymfbRendre(k >= 4 ? 'ok' : 'bad'); }, 350); return;
          }
          if (o) { /* 24/10 (Thibaut) : une seule case */ var dejaOn = o.classList.contains('on'); ymfbEl.querySelectorAll('.ym-fb__opt.on').forEach(function (x) { x.classList.remove('on'); }); if (!dejaOn) o.classList.add('on'); var tx = ymfbEl.querySelector('[data-fb="txt"]'), rr = o.getAttribute('data-fb-r');
            if (ymfbCaseBras === 'b' && tx) { /* 28/10 : bras b, case pour chaque raison */ var Tb = YMFB_TXT[String(listLocale || 'en').slice(0, 2)] || YMFB_TXT.en; tx.hidden = !o.classList.contains('on'); if (!tx.hidden) { tx.placeholder = (rr !== 'other' && Tb.ex && Tb.ex[rr]) || Tb.ph; if (rr === 'other') tx.focus(); } }
            else if (rr === 'other' && tx) { tx.hidden = !o.classList.contains('on'); if (!tx.hidden) tx.focus(); } ymfbMaj(); return; }
          if (b && b.getAttribute('data-fb') === 'again') { var ar = ymfbLire(); if (ar && ar.n) { ar.redo = 1; ymfbGarder(ar); } ymfbLecteur(true); try { var pb = root.querySelector('[data-ym="play-btn"]'); if (pb && audio && audio.paused) pb.click(); } catch (x) {} return; }
          if (b && b.getAttribute('data-fb') === 'send') {
            var a = ymfbLire() || {}; a.r = [].map.call(ymfbEl.querySelectorAll('.ym-fb__opt.on'), function (x) { return x.getAttribute('data-fb-r'); });
            var t2 = ymfbEl.querySelector('[data-fb="txt"]'); a.x = t2 && !t2.hidden ? t2.value.trim().slice(0, 400) : ''; a.envoye = 1; ymfbGarder(a); ymfbEnvoyer();
            a.r.forEach(function (k2) { ymt('preview_fb_' + k2, { rating: a.n || 0, fb_case: ymfbCaseBras }); });
            ymt('preview_fb_send', { rating: a.n || 0, fb_reasons: a.r.join(','), fb_text: a.x.slice(0, 100), fb_case: ymfbCaseBras });
            ymfbRendre('fix');
          }
        });
      }
      var a = ymfbLire();
      // 17/10 (Thibaut) : apres « Reecouter », la fin de l'ecoute repose la question (le dernier avis reste garde tant qu'il n'est pas remplace)
      ymfbRendre('q');   // 18/10 (Thibaut) : chaque fin d'ecoute repose la question, meme apres un rechargement ; le dernier avis reste garde tant qu'il n'est pas remplace
      ymfbLecteur(false);
    } catch (e) {}
  }

  function ymtExit() {
    if (ymtExitSent || !ymtPlayed) return;
    ymtExitSent = true;
    ymt('preview_exit', { transport_type: 'beacon' });
  }
  window.addEventListener('pagehide', ymtExit);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') ymtExit(); });
  if (audio && playBtn) {
    playBtn.addEventListener('click', () => {
      if (audio.paused) {
        if (audio.ended || audio.currentTime >= PREVIEW_MAX_SECONDS - 0.5) audio.currentTime = 0;   // repart du début, jamais de la borne
        audio.play().catch(e => console.warn('[ym-preview] play failed', e));
      }
      else audio.pause();
    });
    function sessionMedia() {
      try {
        if (!('mediaSession' in navigator) || !window.MediaMetadata) return;
        const nom = (previewData && previewData.recipient_name) || '';
        const titre = { fr: nom ? 'La chanson de ' + nom : 'Votre chanson', en: nom ? nom + "'s song" : 'Your song', de: nom ? 'Das Lied für ' + nom : 'Ihr Lied', es: nom ? 'La canción de ' + nom : 'Tu canción', ja: nom ? nom + 'への歌' : 'あなたの歌', it: nom ? 'La canzone per ' + nom : 'La tua canzone', nl: nom ? 'Het lied voor ' + nom : 'Je lied', sv: nom ? 'Låten till ' + nom : 'Din låt', da: nom ? 'Sangen til ' + nom : 'Din sang', nb: nom ? 'Sangen til ' + nom : 'Sangen din', pt: nom ? 'A canção para ' + nom : 'A sua canção', fi: nom ? 'Laulu, jonka saa ' + nom : 'Laulusi' }[String(listLocale || 'fr').slice(0, 2)];
        const art = (previewData && previewData.photo_url) || root.dataset.art || '';
        navigator.mediaSession.metadata = new MediaMetadata({ title: titre, artist: 'YourMelody', album: 'Preview', artwork: art ? [{ src: art, sizes: '512x512', type: 'image/' + (/\.png/i.test(art) ? 'png' : 'jpeg') }] : [] });
        const borne = function (t) { return Math.max(0, Math.min(PREVIEW_MAX_SECONDS - 0.5, t)); };
        navigator.mediaSession.setActionHandler('seekto', function (d) { audio.currentTime = borne(d.seekTime || 0); });
        navigator.mediaSession.setActionHandler('seekforward', function () { audio.currentTime = borne(audio.currentTime + 10); });
        navigator.mediaSession.setActionHandler('seekbackward', function () { audio.currentTime = borne(audio.currentTime - 10); });
        if (navigator.mediaSession.setPositionState) navigator.mediaSession.setPositionState({ duration: PREVIEW_MAX_SECONDS, playbackRate: 1, position: borne(audio.currentTime || 0) });
      } catch (e) {}
    }
    audio.addEventListener('play', () => {
      ymtPlays += 1; if (!ymtPlayed) { ymtPlayed = true; ymt('preview_play', {}); }
      sessionMedia();
      setPlaying(true);
      startProgressTicker();
      signalerLecture();
    });
    audio.addEventListener('pause', () => { setPlaying(false); stopProgressTicker(); try { if (audio.currentTime < PREVIEW_MAX_SECONDS - 0.5 && audio.currentTime > 0.5) ymt('preview_pause', {}); } catch (e) {} });
    audio.addEventListener('ended', () => { setPlaying(false); stopProgressTicker(); ymfbShow(); });
  }

  // ============================================================
  //  Egaliseur pilote par le son
  // ============================================================
  // Les 32 barres suivaient une animation CSS aleatoire. Elles suivent desormais
  // le spectre reel du morceau. L analyse d un fichier distant exige le CORS :
  // cdn.shopify.com et tempfile.aiquickdraw.com renvoient tous deux
  // Access-Control-Allow-Origin: * (verifie le 19/09/2026).
  //
  // Deux garde-fous. On ne branche jamais le son sur un contexte suspendu, sinon
  // la lecture devient muette sur iOS. Et si l analyse ne renvoie que du silence
  // pendant deux secondes, on rend la main a l animation CSS d origine plutot que
  // de laisser des barres figees.
  (function egaliseur() {
    const wave = root.querySelector('.ym-preview__wave');
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!audio || !wave || !AC) return;
    // 04/11 (bmaoggi, iOS 17.0.1) : lecture lancée mais muette. Avant iOS 18, pas de Web Audio : son direct, barres en animation CSS.
    const ios = navigator.userAgent.match(/iP(?:hone|ad|od).*? OS (\d+)_/);
    if (ios && Number(ios[1]) < 18) return;
    const barres = Array.prototype.slice.call(wave.querySelectorAll('i'));
    if (!barres.length) return;

    let ctx = null, analyseur = null, spectre = null, boucle = 0, silence = 0;

    function brancher() {
      if (analyseur) return true;
      try {
        const source = ctx.createMediaElementSource(audio);
        analyseur = ctx.createAnalyser();
        analyseur.fftSize = 128;
        analyseur.smoothingTimeConstant = 0.72;
        source.connect(analyseur);
        analyseur.connect(ctx.destination);
        spectre = new Uint8Array(analyseur.frequencyBinCount);
        return true;
      } catch (e) {
        console.warn('[ym-preview] analyse audio indisponible', e);
        return false;
      }
    }

    function arreter() { if (boucle) { cancelAnimationFrame(boucle); boucle = 0; } }

    function abandonner() {
      arreter();
      wave.classList.remove('ym-preview__wave--live');
      barres.forEach(function (b) { b.style.height = ''; });
      console.warn('[ym-preview] analyse muette, retour a l animation decorative');
    }

    function rendre() {
      if (!analyseur || audio.paused || audio.ended) { arreter(); return; }
      analyseur.getByteFrequencyData(spectre);
      const pas = spectre.length / barres.length;
      let somme = 0;
      for (let i = 0; i < barres.length; i++) {
        const v = spectre[Math.floor(i * pas)] || 0;
        somme += v;
        // les aigus sortent naturellement plus bas, on les relance progressivement
        const gain = 1 + (i / barres.length) * 1.1;
        const h = Math.max(12, Math.min(100, (v / 255) * 100 * gain));
        barres[i].style.height = h.toFixed(1) + '%';
      }
      silence = somme === 0 ? silence + 1 : 0;
      if (silence > 120) { abandonner(); return; }
      boucle = requestAnimationFrame(rendre);
    }

    function demarrer() {
      if (ctx.state !== 'running') return;   // jamais de branchement sur un contexte suspendu
      if (!brancher()) return;
      wave.classList.add('ym-preview__wave--live');
      silence = 0;
      arreter();
      boucle = requestAnimationFrame(rendre);
    }

    audio.addEventListener('play', function () {
      if (!ctx) { try { ctx = new AC(); } catch (e) { return; } }
      if (ctx.state === 'running') demarrer();
      else ctx.resume().then(demarrer).catch(function () {});
    });
    audio.addEventListener('pause', arreter);
    audio.addEventListener('ended', arreter);
  })();

  // ============================================================
  //  Render the preview data into the UI
  // ============================================================
  let previewData = null;

  // Studio note helper: bold the recipient name inside an already-escaped string.
  function boldName(text, nm) {
    if (!nm) return text;
    const e = esc(nm);
    return e ? text.split(e).join('<strong>' + e + '</strong>') : text;
  }

  // ============================================================
  //  Urgency layer — extract expiry countdown + sticky CTA bar
  // ============================================================
  function parseTs(v) {
    if (v === null || v === undefined || v === '') return NaN;
    if (typeof v === 'number') return v < 1e12 ? v * 1000 : v;   // secondes vs ms
    const n = Number(v);
    if (!isNaN(n)) return n < 1e12 ? n * 1000 : n;
    const d = Date.parse(v);                                     // ISO 8601
    return isNaN(d) ? NaN : d;
  }
  // Expiry epoch (ms). Priorité : API expires_at → API generated_at + 24h →
  // ancre localStorage par token (ne redémarre jamais sur le même appareil).
  function getExpiry(data) {
    let exp = parseTs(data.expires_at);
    if (isNaN(exp)) {
      const gen = parseTs(data.generated_at);
      if (!isNaN(gen)) exp = gen + 24 * 3600 * 1000;
    }
    if (isNaN(exp)) {
      const key = 'ym_exp_' + (data.token || 'x');
      const stored = parseInt(localStorage.getItem(key), 10);
      if (stored) { exp = stored; }
      else { exp = Date.now() + 24 * 3600 * 1000; try { localStorage.setItem(key, exp); } catch (e) {} }
    }
    return exp;
  }
  function fmtHMS(ms) {
    if (ms < 0) ms = 0;
    const s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    const p = n => (n < 10 ? '0' : '') + n;
    return p(h) + ':' + p(m) + ':' + p(x);
  }
  let urgencyTicker = null;
  function startUrgency(data) {
    let sticky        = root.querySelector('[data-ym="sticky"]');
    const expiryCard  = root.querySelector('[data-ym="expiry"]');
    const timeEl      = root.querySelector('[data-ym="expiry-time"]');
    const stickyTimer = root.querySelector('[data-ym="sticky-timer"]');
    const stickyCap   = root.querySelector('[data-ym="sticky-cap"]');
    const stickyPrice = root.querySelector('[data-ym="sticky-price"]');
    const stickyBtn   = root.querySelector('[data-ym="sticky-btn"]');
    const playerEl    = root.querySelector('.ym-preview__player');

    // Sticky price follows the selected variant.
    function selPrice() {
      const sel = root.querySelector('[name="ym-variant"]:checked');
      const key = sel ? sel.value : 'express';
      const v = VARIANTS[key] || {};
      return money(v.amount, v.price);
    }
    function syncPrice() { if (stickyPrice) stickyPrice.textContent = selPrice(); }
    root.querySelectorAll('[name="ym-variant"]').forEach(r => r.addEventListener('change', syncPrice));
    syncPrice();

    // Sticky button = same flow as the main buy CTA.
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      const selV = root.querySelector('[name="ym-variant"]:checked');
      if (souvenirState && window.YMSouvenir && (selV ? selV.value : 'express') !== 'express') showSouvenir();
      else submitCart(null);
    });

    // Barre collante retiree le 19/09/2026. Sur mobile elle se superposait au widget
    // de chat, et son bouton envoyait au paiement sans les options cochees plus haut.
    // On la retire du DOM : masquee, elle garderait sa place dans l empilement.
    if (sticky) { sticky.remove(); sticky = null; }
    function onScroll() {
      if (!sticky || !playerEl) return;
      const readyEl = root.querySelector('[data-ym="ready"]');
      const inReady = readyEl && !readyEl.hidden;
      const past = playerEl.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('ym-preview__sticky--show', !!(past && inReady));
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Countdown.
    const expiry = getExpiry(data);
    function tick() {
      const left = expiry - Date.now();
      if (timeEl) timeEl.textContent = fmtHMS(left);
      if (stickyTimer) stickyTimer.textContent = fmtHMS(left);
      if (left <= 0) {
        if (urgencyTicker) clearInterval(urgencyTicker);
        if (expiryCard) expiryCard.hidden = true;             // disparaît simplement
        if (stickyTimer) stickyTimer.style.display = 'none';
        if (stickyCap) stickyCap.textContent = t.stickyCapShort;
      }
    }
    if (!isNaN(expiry) && expiry - Date.now() > 0) {
      if (expiryCard) expiryCard.hidden = false;
      tick();
      urgencyTicker = setInterval(tick, 1000);
    } else {
      if (stickyTimer) stickyTimer.style.display = 'none';
      if (stickyCap) stickyCap.textContent = t.stickyCapShort;
    }
  }

  function renderReady(data) {
    previewData = data;
    restorePhoto(data && data.photo_url);
    photoDejaLa(data);
    memoriserCreation(data);
    clientEstPret();

    // Recipient name (multiple spots)
    const name = data.recipient_name || '';
    recipientNameEls.forEach(el => { el.textContent = name; });
    // 04/10 : texte de l'option streaming repris de la v5 (prenom du destinataire dans le titre).
    try {
      const YM_STREAM = {"fr": ["La chanson de ", " sur Spotify, Apple Music et toutes les plateformes", "Votre chanson sur Spotify, Apple Music et toutes les plateformes", "Trouvable par son nom, au milieu des chansons de tous les jours."], "en": ["", "'s song on Spotify, Apple Music and all platforms", "Your song on Spotify, Apple Music and all platforms", "Found by name, right next to everyday favorites."], "de": ["Das Lied für ", " auf Spotify, Apple Music und allen Plattformen", "Ihr Lied auf Spotify, Apple Music und allen Plattformen", "Per Namen zu finden, direkt neben den Lieblingsliedern."], "es": ["La canción de ", " en Spotify, Apple Music y todas las plataformas", "Tu canción en Spotify, Apple Music y todas las plataformas", "Se puede buscar por su nombre, junto a las canciones de siempre."], "ja": ["", "への歌をSpotify、Apple Musicほか全配信サービスで", "あなたの歌をSpotify、Apple Musicほか全配信サービスで", "名前で検索して、いつもの曲と並べて聴けます。"], "it": ["La canzone per ", " su Spotify, Apple Music e tutte le piattaforme", "La tua canzone su Spotify, Apple Music e tutte le piattaforme", "Si trova cercando il suo nome, accanto alle canzoni di tutti i giorni."], "nl": ["Het lied voor ", " op Spotify, Apple Music en alle platforms", "Je lied op Spotify, Apple Music en alle platforms", "Te vinden op naam, tussen je dagelijkse favorieten."], "sv": ["Låten till ", " på Spotify, Apple Music och alla plattformar", "Din låt på Spotify, Apple Music och alla plattformar", "Sök på namnet och hitta den mitt bland dina vardagsfavoriter."], "da": ["Sangen til ", " på Spotify, Apple Music og alle platforme", "Din sang på Spotify, Apple Music og alle platforme", "Kan findes på navn, lige ved siden af dine daglige favoritter."], "nb": ["Sangen til ", " på Spotify, Apple Music og alle plattformer", "Sangen din på Spotify, Apple Music og alle plattformer", "Søk opp navnet, rett ved siden av favorittene du hører hver dag."], "pt": ["A canção para ", " no Spotify, Apple Music e em todas as plataformas", "A sua canção no Spotify, Apple Music e em todas as plataformas", "Fácil de encontrar pelo nome, ao lado das suas músicas favoritas."], "fi": ["Laulu, jonka saa ", ", Spotifyssa, Apple Musicissa ja kaikilla alustoilla", "Laulusi Spotifyssa, Apple Musicissa ja kaikilla alustoilla", "Löytyy nimellä hakemalla, arjen suosikkien rinnalta."]};
      const ls = YM_STREAM[String(listLocale || 'fr').slice(0, 2)] || YM_STREAM.fr;
      const st = root.querySelector('[data-ym="i18n-streaming-title"]');
      if (st) st.textContent = name ? (ls[0] + name + ls[1]) : ls[2];
      const sd = root.querySelector('[data-ym="i18n-streaming-desc"]');
      if (sd) sd.textContent = ls[3];
    } catch (e) {}

    // Studio note — the AI-generated note from the API if present, else a safe
    // localized fallback (sparse input / generation failure). Both are HTML
    // (contain <strong>). The AI note is plain text from our own pipeline; we
    // still esc() it and only bold the recipient name.
    // Le mot du studio (23/09/2026) : la carte n apparait QUE si l API renvoie un mot, jamais le
    // texte de repli generique. L API aplatit les sauts de ligne : on remet le bonjour sur sa ligne.
    const emo = root.querySelector('[data-ym="emotion-text"]');
    const carteMot = root.querySelector('[data-ym="studio-note"]');
    if (emo) {
      let note = data.studio_note && String(data.studio_note).trim();
      if (note && note.length > 40) {
        note = note.replace(/^((?:Hello|Hi|Bonjour|Hallo|Hola)[^,]{0,25},)\s+/, '$1\n');
        // 21/10 : meme retour a la ligne pour it / nl / ja (seulement dans ces langues ; ja : formule suivie d'une virgule 、).
        if (['it', 'nl', 'sv', 'da', 'nb', 'pt', 'fi'].indexOf(listLocale) > -1) note = note.replace(/^((?:Ciao|Salve|Hoi|Lieve|Beste|Hej|Hei|Moi|Kära|Kære|Kjære|Olá|Querida|Querido|Caro|Cara|Rakas)[^,]{0,25},)\s+/, '$1\n');
        if (listLocale === 'ja') note = note.replace(/^((?:こんにちは|[^、。\s]{1,12}(?:さん|様|ちゃん|くん)?へ)[、，,])\s*/, '$1\n');
        emo.innerHTML = boldName(esc(note), name);
        if (carteMot) carteMot.hidden = false;
      } else if (carteMot) carteMot.hidden = true;
    }

    // Audio source
    if (audio && data.audio_url) {
      // doit etre pose AVANT la source, sinon l analyse du son est impossible
      audio.crossOrigin = 'anonymous';
      audio.src = data.audio_url;
    }

    showState('ready');
    startUrgency(data);
    ymt('preview_reveal');   // 25/10 : la page montre l extrait (lecteur visible)
  }

  // ============================================================
  //  Cart submission (Unlock Full Song Now)
  // ============================================================
  const buyCta = root.querySelector('[data-ym="buy-cta"]');
  const cartErrorEl = root.querySelector('[data-ym="cart-error"]');

  function buildLineItemProperties() {
    if (!previewData) return {};
    const qa = previewData.quiz_answers || {};
    const props = {};
    // Visible to merchant: just the recipient first name (to identify the order at a glance).
    props[t.propRecipientName]  = qa.recipientName || previewData.recipient_name || '';
    // Hidden (underscore prefix = not shown in admin/checkout). The token is what the
    // Order Delivery scenario uses to find the customer + full song. Everything else
    // (lyrics, audio, style, occasion) already lives in the customer metafields, so we
    // no longer clutter the order line item with it.
    props['_locale']        = locale;
    props['_preview_token'] = previewData.token || '';
    // 17/10/2026 : avis laisse a la fin de l'extrait (carte d'avis), visible sur la commande
    try { var ymAv = ymfbAvisTexte(); if (ymAv) props['_ym_avis'] = ymAv; } catch (e) {}
    // Drop empties
    Object.keys(props).forEach(k => { if (!props[k]) delete props[k]; });
    return props;
  }

  // Multipart /cart/add.js — uploads the photo File AND adds the physical product (plaque/magnet) in one call.
  async function uploadPhotoForVariant(variantId, extraProps, file) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    Object.keys(extraProps || {}).forEach(function (k) {
      const v = extraProps[k];
      if (v !== null && v !== undefined && String(v).length > 0) {
        fd.append('properties[' + k + ']', String(v));
      }
    });
    fd.append('properties[Photo]', file, file.name);
    const resp = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error('Photo upload failed (' + resp.status + '): ' + text.slice(0, 200));
    }
    return resp.json();
  }

  async function submitCart(physical) {
    if (!previewData) return;
    if (cartErrorEl) { cartErrorEl.hidden = true; cartErrorEl.textContent = ''; }

    // Get selected variant
    const selected = root.querySelector('[name="ym-variant"]:checked');
    const variantKey = selected ? selected.value : 'express';
    const mainVariantId = variantKey === 'express' ? VARIANTS.express.id : VARIANTS.standard.id;
    if (!mainVariantId) {
      if (cartErrorEl) { cartErrorEl.textContent = t.cartError + ' (variant config missing)'; cartErrorEl.hidden = false; }
      return;
    }

    const streamingChecked = !!root.querySelector('[data-ym="addon-streaming"]:checked');
    const props = buildLineItemProperties();

    const items = [{ id: Number(mainVariantId), quantity: 1, properties: props }];
    if (streamingChecked && VARIANTS.streaming.id) {
      items.push({ id: Number(VARIANTS.streaming.id), quantity: 1 });
    }
    const lyricsChecked = !!root.querySelector('[data-ym="addon-lyrics"]:checked');
    if (lyricsChecked && VARIANTS.lyrics.id) {
      items.push({ id: Number(VARIANTS.lyrics.id), quantity: 1 });
    }

    // Souvenir physique (plaque/magnet [+ socle]) — optional, chosen on the souvenir step.
    const sv = (window.YMSouvenir && window.YMSouvenir.variants) || {};
    const hasPhysical = !!(physical && physical.product);
    if (hasPhysical && physical.product === 'plaque' && physical.socle && sv.socle) {
      items.push({ id: Number(sv.socle), quantity: 1 });
    }

    buyCta.disabled = true;
    if (window.YMSouvenir) window.YMSouvenir.setBusy(true);
    try {
      // 29/09/2026 : le checkout ne permet pas de modifier le panier. On repart d un panier vide a chaque clic
      // pour que seule la derniere selection parte au paiement (double ligne 30 min + 48 h vue sur des commandes).
      try { await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }); } catch (e) {}
      // 1. If a plaque/magnet + photo were chosen, upload the photo first (separate multipart call).
      if (hasPhysical && physical.photoFile) {
        const physVariantId = physical.product === 'plaque' ? sv.plaque : sv.magnet;
        if (physVariantId && !isNaN(Number(physVariantId))) {
          await uploadPhotoForVariant(Number(physVariantId), window.YMSouvenir.buildPhysicalProperties(), physical.photoFile);
        }
      }

      // 2. JSON batch add (song [+ streaming] [+ socle]).
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error('Cart add failed (' + resp.status + '): ' + txt.slice(0, 200));
      }

      // Tracking (dataLayer)
      try {
        // Meta Pixel : AddToCart / InitiateCheckout retires le 2026-09-14, le canal Facebook de Shopify les envoie deja (avec event id).
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push({ event: 'ym_preview_unlock', variant: variantKey, streaming: streamingChecked, souvenir: hasPhysical ? physical.product : 'none' });
        }
      } catch (e) {}

      ymt('preview_unlock', { variant: String(variantKey || ''), streaming: streamingChecked ? 1 : 0, souvenir: hasPhysical ? String(physical.product || '') : 'none' });   // 25/10 : clic unlock, panier accepte
      // Redirect to checkout
      ymt('preview_checkout', { variant: String(variantKey || '') });   // 25/10 : depart vers le paiement
      window.location.href = ymCheckoutUrl(items, !!(hasPhysical && physical.photoFile));
    } catch (err) {
      console.error('[ym-preview] cart error', err);
      buyCta.disabled = false;
      if (window.YMSouvenir) { window.YMSouvenir.setBusy(false); window.YMSouvenir.showFormError(t.cartError); }
      if (cartErrorEl) {
        cartErrorEl.textContent = t.cartError;
        cartErrorEl.hidden = false;
      }
    }
  }

  // Buy CTA → show the souvenir upsell step first (instead of going straight to checkout).
  // The express/standard radio + streaming checkbox stay in the (hidden) ready DOM, so
  // submitCart() can still read them at confirm/skip time.
  const souvenirState = root.querySelector('[data-ym="souvenir"]');
  const readyState = root.querySelector('[data-ym="ready"]');
  function showSouvenir() {
    if (readyState) readyState.hidden = true;
    if (souvenirState) souvenirState.hidden = false;
    const sk = root.querySelector('[data-ym="sticky"]');
    if (sk) sk.classList.remove('ym-preview__sticky--show');
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  }
  // « Retour » : on revient aux offres, l ecran precedent du tunnel.
  function retourAuxOffres() {
    if (souvenirState) souvenirState.hidden = true;
    if (readyState) readyState.hidden = false;
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  }
  const souvenirBack = root.querySelector('[data-ym="souvenir-back"]');
  if (souvenirBack) souvenirBack.addEventListener('click', retourAuxOffres);

  if (buyCta) {
    buyCta.addEventListener('click', function () {
      // 04/10/2026 : 30 minutes = achat urgent, on passe directement au paiement (pas d'ecran souvenir).
      const selV = root.querySelector('[name="ym-variant"]:checked');
      const express = (selV ? selV.value : 'express') === 'express';
      if (souvenirState && window.YMSouvenir && !express) showSouvenir();
      else submitCart(null); // 30 min, ou composant souvenir absent → paiement direct
    });
  }
  // 04/10/2026 : retour depuis le paiement (cache du navigateur) → bouton reactive.
  window.addEventListener('pageshow', function () {
    if (buyCta) buyCta.disabled = false;
    try { if (window.YMSouvenir && window.YMSouvenir.setBusy) window.YMSouvenir.setBusy(false); } catch (e) {}
  });
  if (window.YMSouvenir) {
    window.YMSouvenir.onSkip(function () { submitCart(null); });
    window.YMSouvenir.onConfirm(function (sel) { submitCart(sel); });
  }

  // ============================================================
  //  Boot — fetch preview data or use test mode
  // ============================================================
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('t');

  function tryTestMode() {
    const testAudio = urlParams.get('audio');
    const testName = urlParams.get('name');
    if (testAudio && testName) {
      renderReady({
        audio_url: testAudio,
        recipient_name: decodeURIComponent(testName.replace(/\+/g, ' ')),
        lyrics: urlParams.get('lyrics') ? decodeURIComponent(urlParams.get('lyrics').replace(/\+/g, ' ')) : '',
        style: urlParams.get('style') ? decodeURIComponent(urlParams.get('style').replace(/\+/g, ' ')) : '',
        relation: urlParams.get('relation') ? decodeURIComponent(urlParams.get('relation').replace(/\+/g, ' ')) : '',
        quiz_answers: {},
        token: 'test'
      });
      return true;
    }
    return false;
  }

  // Client tokens are "p_<base36 Date.now()>_<rand>": a token minted more than 15 min ago
  // that is still unknown is a dead link, not the capture race, so fail fast for those.
  function tokenIsFresh() {
    // 28/09/2026 : compte depuis l ENVOI du quiz (parametre s), pas depuis le chargement de la page du
    // quiz (date du jeton) : un quiz rempli en plus de 15 min affichait « extrait introuvable ».
    let minted = NaN;
    try { const s = new URLSearchParams(location.search).get('s'); if (s) minted = parseInt(s, 36); } catch (e) {}
    if (!isFinite(minted)) {
      const m = /^p_([0-9a-z]+)_/i.exec(token || '');
      if (!m) return false;
      minted = parseInt(m[1], 36);
    }
    return isFinite(minted) && (Date.now() - minted) < 15 * 60 * 1000;
  }

  // Duree de tenue de la page d attente (preview-wait-v3.js). Tant qu elle court,
  // la reponse de l API ne peut RIEN declencher : inutile de la redemander toutes
  // les 30 s. On dort jusqu a la fin de la tenue, puis on reprend le rythme normal.
  // 50 min depuis l heure du jeton (decision du 22/09/2026), comme dans preview-wait-v3.js.
  const HOLD_MS = 50 * 60 * 1000;
  function tokenTime() {
    const m = /^p_([0-9a-z]+)_/.exec(token || '');
    if (!m) return null;
    const t = parseInt(m[1], 36);
    if (!isFinite(t) || t > Date.now() + 60000 || Date.now() - t > 3 * 60 * 60 * 1000) return null;
    return t;
  }
  // Heure d envoi du quiz (&s=, memoire locale, creation du client via l API), sinon le jeton.
  function submitTime() {
    const key = 'ym_sub_' + (token || 'x');
    let v = NaN;
    try { const s = new URLSearchParams(location.search).get('s'); if (s) v = parseInt(s, 36); } catch (e) {}
    if (!isFinite(v)) { try { v = parseInt(localStorage.getItem(key), 10); } catch (e) { v = NaN; } }
    if (isFinite(v) && v > 0 && v < Date.now() + 60000) { try { localStorage.setItem(key, v); } catch (e) {} return v; }
    return null;
  }
  function memoriserCreation(d) {
    const c = d && d.created_at ? Date.parse(d.created_at) : NaN;
    if (isFinite(c)) { try { localStorage.setItem('ym_sub_' + (token || 'x'), c); } catch (e) {} }
  }
  function holdLeft() {
    try {
      let v = submitTime();
      if (v === null) v = tokenTime();
      if (v === null) v = parseInt(localStorage.getItem('ym_wait_' + (token || 'x')), 10);
      if (v === null || isNaN(v)) return 0;
      const r = HOLD_MS - (Date.now() - v);
      return r > 0 ? r : 0;
    } catch (e) { return 0; }
  }
  function nextDelay(base) {
    const left = holdLeft();
    return left > base ? left + 5000 : base;
  }

  async function fetchPreview(retry) {
    retry = retry || 0;
    if (!apiUrl) {
      console.warn('[ym-preview] No API URL configured. Test mode only.');
      showState('error');
      return;
    }
    try {
      const resp = await fetch(apiUrl + '?t=' + encodeURIComponent(token), {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });
      if (!resp.ok) throw new Error('API ' + resp.status);
      // Make answers a plain-text "Accepted" (not JSON) when the token is unknown:
      // treat any non-JSON body as "not found" rather than as a network error.
      const bodyText = await resp.text();
      let data = null;
      try { data = JSON.parse(bodyText); } catch (e) { data = null; }
      // 27/09/2026 : la reponse est partagee avec preview-wait-v3.js (prenom sur la page d'attente),
      // qui n'appelle plus Make de son cote : une seule execution Data API par ouverture.
      try { window.__ymPreview = data; document.dispatchEvent(new CustomEvent('ym:preview-data', { detail: data })); } catch (e) {}

      if (data && data.audio_url) {
        // Robust: if the audio exists, the preview IS ready — show it even if the
        // preview_status flag is stale "pending" (a re-run of the capture can reset
        // the flag without clearing the audio). The audio's presence is the real proof.
        renderReady(data);
      } else if (data && (data.status === 'pending' || data.status === 'processing')) {
        // Song is generating (~3 min typical, rare outliers up to ~30 min). Poll every 30s
        // for ~22 min, then tell the customer it is taking longer and keep a slow poll
        // (every 2 min for another hour) so the page still reveals itself if they stay.
        showState('pending');
        previewData = data;
        restorePhoto(data && data.photo_url);
    photoDejaLa(data);
    memoriserCreation(data);
    clientEstPret();
        if (retry < 44) setTimeout(() => fetchPreview(retry + 1), nextDelay(30000));
        else if (retry < 74) { setText('pending-hint', t.pendingLate || t.pendingHint); setTimeout(() => fetchPreview(retry + 1), 120000); }
      } else if (retry < 30 && tokenIsFresh()) {
        // Capture race: the customer + preview_token metafield is written ~10s AFTER
        // submit (OpenAI + Suno run first inside the Capture scenario), so a freshly
        // submitted token is briefly "not found". NEVER flash "not found" while the
        // song is being created — show the wait page and poll fast (~3 min budget)
        // before finally declaring the link invalid.
        showState('pending');
        // 6 s seulement le temps que Capture ecrive le client (5 a 11 s), puis rythme aligne.
        setTimeout(() => fetchPreview(retry + 1), retry < 5 ? 6000 : nextDelay(30000));
      } else {
        showState('error');
      }
    } catch (e) {
      console.error('[ym-preview] fetch error', e);
      if (retry < 30) {
        showState('pending');
        // 6 s seulement le temps que Capture ecrive le client (5 a 11 s), puis rythme aligne.
        setTimeout(() => fetchPreview(retry + 1), retry < 5 ? 6000 : nextDelay(30000));
      } else {
        showState('error');
      }
    }
  }

  if (!token) {
    showState('error');
  } else if (!tryTestMode()) {
    fetchPreview();
  }

  initPhoto();   // apres la declaration du jeton
  rattacherPhotoDuQuiz();   // photo eventuellement deposee des le questionnaire
  console.info('[ym-preview] init · locale=' + listLocale + ' · token=' + (token ? 'present' : 'missing'));
})();
